import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  TemplateRef,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { Subscription } from 'rxjs';
import { AnalyticsService } from '../../@core/utils/analytics.service';
import { validateNoWhitespace } from '../../@theme/directives/validators';
import { DUMMY_CLASSROOMS } from '../../config/dummy_classroom';
import { LessonPlan_Privacy } from '../../enum/lesson-plan-privacy';
import { ROLEVALUES, UserRoles } from '../../enum/roles.enum';
import { AssignmentsService } from '../../services/assignments.service';
import { AuthService } from '../../services/auth.service';
import { CalendarService } from '../../services/calendar.service';
import { ClassroomService } from '../../services/classroom.service';
import dayjs from '../../services/dayjs.service';
import { GradeService } from '../../services/grade.service';
import { LessonPlanService } from '../../services/lesson-plan.service';
import { OpenAiAssistantService } from '../../services/open-ai-assistant.service';
import { OpenAIService } from '../../services/open-ai.service';
import { PacingPlanService } from '../../services/pacing-plan.service';
import { StorageService } from '../../services/storage.service';
import { StudentService } from '../../services/student.service';
import { SubjectService } from '../../services/subject.service';
import { TeacherLessonPlanService } from '../../services/teacher-lesson-plan.service';
import { ToasterService } from '../../services/toaster.service';
import { UtilService } from '../../services/util.service';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { Location } from '@angular/common';
import { gptModel } from '../../enum/gpt-model';
import { EMAIL_TEMPLATE_TYPE } from '../../enum/time_automated_emails.enum';
import { AssignmentQuestion } from '../../interface/assignment';
import { AcademicYearService } from '../../services/academic-year.service';
import { AutomatedEmailsService } from '../../services/automated-emails.service';

@Component({
  selector: 'ngx-lesson-plan',
  templateUrl: './lesson-plan.component.html',
  styleUrls: ['./lesson-plan.component.scss'],
})
export class LessonPlanComponent implements OnInit, OnDestroy {
  @Input() lessonPlan;
  @Input() classroomId;
  interval;
  @Input() isModal = false;
  addLessonPlanForm: FormGroup;
  lessonPlanForm: FormGroup;
  englishlessonPlanForm: FormGroup;
  @Output() closeExpandViewModal = new EventEmitter<boolean>();
  isCounter = false;
  remainingTime;
  loadingText = 'Please wait...';
  lastPacingPlanDate = new Date();
  isShowInputField = false;
  youTubeUrl;
  videoUrls = [];
  addVideoUrls = [];
  user;
  currentRankedPlan = [];
  currentLessonPlan;
  currentClassroom: any;
  @Input() newLessonPlan;
  @Input() isPacingPlan = false;
  lessonPlanMedia;
  youtubeUrlForm: FormGroup;
  private dialogRef: NbDialogRef<any>;
  @ViewChild('callAPIDialog') callAPIDialog: TemplateRef<any>;
  @ViewChild('viewYouTubeUrl') viewYouTubeUrl: TemplateRef<any>;
  @ViewChild('newLessonPlanContent') newLessonPlanContent: TemplateRef<any>;
  @ViewChild('lessonPlanPrivacyDialog')
  lessonPlanPrivacyDialog: TemplateRef<any>;
  @ViewChild('save') save: TemplateRef<any>;
  // @ViewChild('uploadedDocument') uploadedDocument: TemplateRef<any>;
  isRanked = false;
  customYouTubeUrl = '';
  isSave = false;
  private presentationStreamSub: Subscription;
  averagePercentage: number = 0;
  remainingMinute: number = 0;
  loading = false;
  isStudent = false;
  isValidSources = false;
  isDisabledPresentation = true;
  pushLessonPlan = false;
  privacyOption: number;
  privacyOptions = LessonPlan_Privacy;
  easyQuestionsInDatabase = [];
  difficultQuestionsInDatabase = [];
  existedLessonPlanIds: number[];
  isCreateAssignment = false;
  userAccessToken: any;
  userAccessAIToken: any;
  private currentLessonPlanType: any;
  @ViewChild('lessonPlanModal') lessonPlanModal;
  englishLessonPlan;
  isEnglishLessonPlan: boolean = false;
  isMobileScreen: boolean;
  @HostListener('window:resize', ['$event'])
  sectionTitles: string[];
  addVideoUrlsBySection;
  activeSection: string = ''; // Default to the first section
  combinedPacingPlans;
  displayedText: string = ''; // Holds the text being typed out
  private currentIndex: number = 0; // Tracks the current position of the text being typed
  fullText: string = ''; // Holds the full text to type out
  isTeacherOnly: boolean = false;
  selectedQuestionType = '';
  generatedQuestions;
  isAIGeneratedPlan;
  isEditing = false;
  addedMediaFile = false;
  highlightPresentation = false;
  homeworkAssignmentQuestion: any[];
  lessonPlanQuestions: any;
  questions: AssignmentQuestion[];
  lessonPlanId: number;
  selectedLessonPlanId: number = 0;
  alreadyExistEasyQuestions: string = '';
  alreadyExistDifficultQuestions: string = '';
  attachedDocumentId: number = 0;
  baseLessonPlanId: number = 0;
  isDeleteLessonPlan = false;
  tempSelectedVideoUrls: SafeResourceUrl[] = [];
  showLessonPlanSpinner: boolean = false;
  jsonStreamBuffer = '';
  englishNovelPlan: any;
  isFirstClassroomMailSent: boolean;
  onResize(event: any): void {
    this.isMobileScreen = event.target.innerWidth <= 800;
  }

  constructor(
    private fb: FormBuilder,
    private lessonPlanService: LessonPlanService,
    private pacingPlanService: PacingPlanService,
    public storageService: StorageService,
    private router: Router,
    private calendarService: CalendarService,
    public matDialog: MatDialog,
    private subjectService: SubjectService,
    private openAiService: OpenAIService,
    private classroomService: ClassroomService,
    private toasterService: ToasterService,
    private assignmentService: AssignmentsService,
    private teacherLessonPlanService: TeacherLessonPlanService,
    private gradeService: GradeService,
    private dialogService: NbDialogService,
    private route: ActivatedRoute,
    private studentService: StudentService,
    private authService: AuthService,
    public analyticsService: AnalyticsService,
    public modalService: NgbModal,
    public OpenAiAssistant: OpenAiAssistantService,
    public localStorageService: StorageService,
    private spinner: NgxSpinnerService,
    private utilService: UtilService,
    private navigateBack: Location,
    private emailService: AutomatedEmailsService,
    private academicYearService: AcademicYearService,
  ) {}

  async ngOnInit() {
    try {
      this.route.queryParams.subscribe(async (res) => {
        this.selectedLessonPlanId = this.newLessonPlan?.id ? this.newLessonPlan?.id : Number(res.id);
        this.baseLessonPlanId =
          Number(res.lesson_plan_id) || this.newLessonPlan?.lesson_plan_id || this.newLessonPlan?.id;
      });
      // Disable academic year header
      this.academicYearService.disableAcademicHeader.next(true);
      await this.getFormControls();
      this.isAIGeneratedPlan = this.localStorageService.getItem('isAIGeneratedPlan');
      this.pushLessonPlan = this.route?.snapshot?.queryParams?.pushLessonPlan === 'true' ? true : false;

      this.isStudent = this.lessonPlan && this.lessonPlan.isStudent ? true : false;
      //remove the english novel related data if the subject is not related to English
      const currentSubject = this.storageService.getItem('currentClassroomSubject') || {};
      if (currentSubject && currentSubject.id !== 15 && currentSubject.id !== 24) {
        this.storageService.removeItem('englishStoryData');
      }
      this.isEnglishLessonPlan = this.storageService.getItem('englishStoryData') ? true : false;
      if (this.isEnglishLessonPlan) {
        this.englishNovelPlan = this.storageService.getItem('englishStoryData');
      }

      this.spinner.show();
      this.user = this.storageService.getItem('user');
      this.isTeacherOnly = this.user.user.role_id === ROLEVALUES.TEACHER_ONLY ? true : false;
      this.currentClassroom =
        this.user.user.is_trial_user && this.classroomId === 1
          ? DUMMY_CLASSROOMS[0]
          : await this.classroomService.classroomById(this.classroomId);

      this.newLessonPlan ? await this.patchLessonPlanForm(true) : await this.patchLessonPlanForm(false);
      // await this.getDifficultAndEasyQuestions();

      if (this.storageService.checkUserRole(this.user.user.role_id, 'teacher_only')) {
        this.privacyOptions = this.privacyOptions.filter((option) => option.value !== 2);
      }

      if (this.storageService.getItem('document')) {
        this.storageService.setItem('document', false);
      }

      await this.getUserAIToken();
      this.spinner.hide();

      // this.getUserToken();// token_used table functions
    } catch (error) {
      this.spinner.hide();
    }
  }

  async getDifficultAndEasyQuestions(isNew) {
    try {
      if (isNew) {
        let pacingPlanId: any[] = [];
        let teacherCustomPacingPlanId: any[] = [];

        if (this.newLessonPlan) {
          if (this.newLessonPlan.user_id) {
            const lessonPlan = this.newLessonPlan.lesson_plan;
            if (lessonPlan.pacing_plan_id?.length > 0) {
              pacingPlanId = lessonPlan.pacing_plan_id.filter((plan: any) => plan !== null).map((plan: any) => plan.id);
            }
            if (lessonPlan.teacher_custom_pacing_plans_id?.length > 0) {
              teacherCustomPacingPlanId = lessonPlan.teacher_custom_pacing_plans_id
                .filter((plan: any) => plan !== null)
                .map((plan: any) => plan.id);
            }
          } else {
            if (this.newLessonPlan.pacing_plan_id?.length > 0) {
              pacingPlanId = this.newLessonPlan.pacing_plan_id
                .filter((plan: any) => plan !== null)
                .map((plan: any) => plan.id);
            }
            if (this.newLessonPlan.teacher_custom_pacing_plans_id?.length > 0) {
              teacherCustomPacingPlanId = this.newLessonPlan.teacher_custom_pacing_plans_id
                .filter((plan: any) => plan !== null)
                .map((plan: any) => plan.id);
            }
          }
        } else {
          const lessonPlan = this.lessonPlan.lesson_plan;
          if (lessonPlan.pacing_plan_id?.length > 0) {
            pacingPlanId = lessonPlan.pacing_plan_id.filter((plan: any) => plan !== null).map((plan: any) => plan.id);
          }
          if (lessonPlan.teacher_custom_pacing_plans_id?.length > 0) {
            teacherCustomPacingPlanId = lessonPlan.teacher_custom_pacing_plans_id
              .filter((plan: any) => plan !== null)
              .map((plan: any) => plan.id);
          }
        }
        // const body = {
        //   global_pacing_plan_id:
        //     this.newLessonPlan?.lesson_plan?.pacing_plan_id.length > 0 &&
        //     this.newLessonPlan?.lesson_plan?.pacing_plan_id.some((id) => id !== null)
        //       ? pacingPlanId
        //       : [],
        //   teacher_custom_pacing_plans_id:
        //     this.newLessonPlan?.lesson_plan?.teacher_custom_pacing_plans_id.length > 0 &&
        //     this.newLessonPlan?.lesson_plan?.teacher_custom_pacing_plans_id.some((id) => id !== null)
        //       ? teacherCustomPacingPlanId
        //       : [],
        // };
        // if (this.alreadyExistEasyQuestions && this.alreadyExistEasyQuestions !== '' && !this.isAIGeneratedPlan) {
        //   this.addLessonPlanForm.patchValue({
        //     easyQuestions: this.alreadyExistEasyQuestions?.replace(/(\s*\n\s*){2,}/g, '\n'),
        //   });
        // }
        // if (
        //   this.alreadyExistDifficultQuestions &&
        //   this.alreadyExistDifficultQuestions !== '' &&
        //   !this.isAIGeneratedPlan
        // ) {
        //   this.addLessonPlanForm.patchValue({
        //     difficultQuestions: this.alreadyExistDifficultQuestions?.replace(/(\s*\n\s*){2,}/g, '\n'),
        //   });
        // }
        // previous logic
        //   const easyQuestions: any = await this.pacingPlanService.getEasyQuestionsByPacingPlanId(body);
        //   const difficultQuestions: any = await this.pacingPlanService.getDifficultQuestionsByPacingPlanId(body);
        //   if (easyQuestions && easyQuestions.length > 0 && !this.isAIGeneratedPlan) {
        //     this.addLessonPlanForm.patchValue({
        //       easyQuestions: easyQuestions[0]?.questions?.replace(/(\s*\n\s*){2,}/g, '\n'),
        //     });
        //   }

        //   if (difficultQuestions && difficultQuestions.length > 0 && !this.isAIGeneratedPlan) {
        //     this.addLessonPlanForm.patchValue({
        //       difficultQuestions: difficultQuestions[0]?.questions?.replace(/(\s*\n\s*){2,}/g, '\n'),
        //     });
        //   }
        // }
      } else {
        if (this.currentLessonPlan && this.currentLessonPlan.updates) {
          const easyQuestions = this.currentLessonPlan.updates.find((update) => update.easyQuestions)?.easyQuestions;
          const difficultQuestions = this.currentLessonPlan.updates.find(
            (update) => update.difficultQuestions,
          )?.difficultQuestions;

          if (easyQuestions && !this.isAIGeneratedPlan) {
            this.addLessonPlanForm.patchValue({ easyQuestions });
          }
          if (difficultQuestions && !this.isAIGeneratedPlan) {
            this.addLessonPlanForm.patchValue({ difficultQuestions });
          }
        }
      }
    } catch (error) {
      console.log('getDifficultAndEasyQuestions', error);
    }
  }

  async patchLessonPlanForm(isNew = false) {
    try {
      this.currentLessonPlan = isNew ? await this.getNewLessonPlan() : await this.getLessonPlan();
      await this.checkCurrentLessonPlanRanking();
      if (this.currentLessonPlan.lesson_plan_media_id > 0 || this.attachedDocumentId > 0) {
        const media = await this.lessonPlanService.getLessonPlanMedia(
          this.currentLessonPlan.lesson_plan_media_id || this.attachedDocumentId,
        );
        this.lessonPlanMedia = media;
      }

      let subjectGrade;

      if (this.currentLessonPlan && this.currentLessonPlan?.teacher_custom_pacing_plans_id?.length > 0) {
        this.addLessonPlanForm.patchValue({
          //patched multiple values
          sectionId: this.currentLessonPlan?.teacher_custom_pacing_plans_id
            ?.map((plan) => (plan?.section_id ? plan?.section_id : ''))
            .join('\n'),
          sectionTitle: this.currentLessonPlan?.teacher_custom_pacing_plans_id
            ?.map((plan) => plan?.section_title)
            .join('\n'),
          // sectionId: this.currentLessonPlan.teacher_custom_pacing_plans
          //   .section_id
          //   ? this.currentLessonPlan.teacher_custom_pacing_plans.section_id
          //   : '-',
          // sectionTitle:
          //   this.currentLessonPlan.teacher_custom_pacing_plans.section_title,
        });
      }
      if (this.currentLessonPlan && this.currentLessonPlan?.custom_global_pacing_plan) {
        this.addLessonPlanForm.patchValue({
          sectionId: this.currentLessonPlan.custom_global_pacing_plan.section_id
            ? this.currentLessonPlan.custom_global_pacing_plan.section_id
            : '-',
          sectionTitle: this.currentLessonPlan.custom_global_pacing_plan.section_title,
        });
      }
      if (this.currentLessonPlan && !this.currentLessonPlan?.custom_global_pacing_plan) {
        // const res = this.getSectionData('section_id', isNew);
        this.addLessonPlanForm.patchValue({
          sectionId: this.getSectionData('section_id', isNew),
          sectionTitle: this.getSectionData('section_title', isNew),
        });
        //   //for single ID
        //   // sectionId: isNew
        //   //   ? this.currentLessonPlan?.pacing_plan?.section_id
        //   //   : this.currentLessonPlan?.lesson_plan_id !== 0
        //   //   ? this.currentLessonPlan?.lesson_plan
        //   //       .teacher_custom_pacing_plans_id !== 0
        //   //     ? this.currentLessonPlan?.lesson_plan.teacher_custom_pacing_plans
        //   //         .section_id
        //   //     : this.currentLessonPlan?.lesson_plan.pacing_plan.section_id
        //   //   : this.currentLessonPlan?.lesson_plan.section_id,
        //   // sectionTitle: isNew
        //   //   ? this.currentLessonPlan?.pacing_plan?.section_title
        //   //   : this.currentLessonPlan?.lesson_plan_id !== 0
        //   //   ? this.currentLessonPlan?.lesson_plan
        //   //       .teacher_custom_pacing_plans_id !== 0
        //   //     ? this.currentLessonPlan?.lesson_plan.teacher_custom_pacing_plans
        //   //         .section_title
        //   //     : this.currentLessonPlan?.lesson_plan.pacing_plan.section_title
        //   //   : this.currentLessonPlan?.lesson_plan.section_title,
        // });
      }
      const currentClassroomSubject = this.storageService.getItem('currentClassroomSubject') || 0;

      subjectGrade = await this.getGradeAndSubject(
        this.currentLessonPlan && this.currentLessonPlan.grades_id
          ? this.currentLessonPlan.grades_id
          : this.currentClassroom?.grades_id,
        isNew
          ? this.currentLessonPlan?.pacing_plan_id.length > 0
            ? currentClassroomSubject.id
            : this.currentLessonPlan?.lesson_plan
              ? this.currentLessonPlan?.lesson_plan.pacing_plan_id[0].subject_id
              : this.currentLessonPlan?.custom_global_pacing_plan_id.length > 0
                ? this.currentLessonPlan?.custom_global_pacing_plan_id[0]?.subject_id
                : this.currentLessonPlan?.teacher_custom_pacing_plans_id[0]?.subject_id
          : this.currentLessonPlan?.subject_id
            ? this.currentLessonPlan?.subject_id
            : this.currentLessonPlan?.lesson_plan.pacing_plan_id[0]?.subject_id,
      );

      this.addLessonPlanForm.patchValue({
        start: isNew ? new Date() : new Date(Number(this.currentLessonPlan.start)),
        end: isNew ? new Date(this.currentLessonPlan.end) : new Date(Number(this.currentLessonPlan.end)),
        objective: isNew ? this.currentLessonPlan.objective : this.currentLessonPlan.lesson_plan.objective,
        anticipatory_set: isNew
          ? this.currentLessonPlan.anticipatory_set
          : this.currentLessonPlan.lesson_plan.anticipatory_set,
        presentation:
          this.isEnglishLessonPlan && isNew
            ? this.englishNovelPlan.presentation
            : isNew
              ? this.currentLessonPlan.presentation
              : this.currentLessonPlan.lesson_plan.presentation,
        guided_practice_questions:
          this.isEnglishLessonPlan && isNew
            ? this.englishNovelPlan?.guided_practice_questions
            : isNew
              ? this.currentLessonPlan?.guided_practice_questions
              : this.currentLessonPlan?.lesson_plan?.guided_practice_questions,
        homework_questions:
          this.isEnglishLessonPlan && isNew
            ? this.englishNovelPlan.homework_questions
            : isNew
              ? this.currentLessonPlan.homework_questions
              : this.currentLessonPlan.lesson_plan.homework_questions,
        closure:
          this.isEnglishLessonPlan && isNew
            ? this.englishNovelPlan.closure
            : isNew
              ? this.currentLessonPlan.closure
              : this.currentLessonPlan.lesson_plan.closure,
        easyQuestions: this.currentLessonPlan.easyQuestions ? this.currentLessonPlan.easyQuestions : null,
        difficultQuestions: this.currentLessonPlan.difficultQuestions
          ? this.currentLessonPlan.difficultQuestions
          : null,
        subject:
          this.currentLessonPlan.lesson_plan_id !== 0
            ? subjectGrade?.subject?.subject
            : this.currentLessonPlan.lesson_plan.subject,
        grade:
          this.currentLessonPlan.lesson_plan_id !== 0
            ? subjectGrade?.grade?.grade
            : this.currentLessonPlan.lesson_plan.grade,
      });
      if (this.currentLessonPlan && this.currentLessonPlan.video_urls && this.currentLessonPlan.video_urls.length > 0) {
        this.videoUrls = [];
        this.videoUrls = await this.updateYouTubeUrls();
        // this.extractVideoIds();
        // this.loadYouTubeAPI();
      }
      this.lessonPlanForm.patchValue({
        title:
          this.isEnglishLessonPlan && isNew
            ? this.englishNovelPlan.title
            : this.currentLessonPlan.title
              ? this.currentLessonPlan.title
              : this.currentLessonPlan?.updates?.[10]?.title || '',
        author:
          this.isEnglishLessonPlan && isNew
            ? this.englishNovelPlan.author
            : this.currentLessonPlan.author
              ? this.currentLessonPlan.author
              : this.currentLessonPlan?.updates?.[11]?.author || '',
        chapter:
          this.isEnglishLessonPlan && isNew
            ? this.englishNovelPlan.chapter || ''
            : this.currentLessonPlan.chapter
              ? this.currentLessonPlan.chapter
              : this.currentLessonPlan?.updates?.[12]?.chapter || '',
      });

      // stored the values in the localstorage during updating
      if (
        (this.currentLessonPlan.title && this.currentLessonPlan.author) ||
        (this.currentLessonPlan?.updates?.[10]?.title && this.currentLessonPlan?.updates?.[11]?.author)
      ) {
        this.localStorageService.setItem('englishStoryData', {
          ...(this.lessonPlanForm.value ? this.lessonPlanForm.value : this.lessonPlan),
          isEnglishLessonPlan: this.lessonPlanForm.value === '' ? false : true,
        });
      }
      await this.getDifficultAndEasyQuestions(isNew);

      if (!isNew) {
        if (this.currentLessonPlan.end > new Date().getTime()) {
          this.isCounter = true;
          await this.setCounter();
        } else {
          this.isCounter = false;
        }
      }
    } catch (error) {}
  }

  private getSectionData(key: 'section_id' | 'section_title', isNew: boolean): string {
    try {
      const getMappedData = (plans: any[]) =>
        plans
          ?.filter((plan) => plan?.[key])
          ?.map((plan) => (plan?.[key] ? plan?.[key].replace(/\s+/g, ' ').trim() : '-'))
          .join(key === 'section_id' ? '\n' : '\n\n') || '-';

      if (isNew) {
        const combinedPlans = [
          ...(this.currentLessonPlan?.pacing_plan_id || []),
          ...(this.currentLessonPlan?.teacher_custom_pacing_plans_id || []),
        ];
        this.combinedPacingPlans = combinedPlans.filter((id) => id);
        return getMappedData(combinedPlans);
        // return getMappedData(this.currentLessonPlan?.pacing_plan_id);
      }

      if (this.currentLessonPlan?.lesson_plan_id !== 0) {
        const teacherCustomPlans = this.currentLessonPlan?.lesson_plan.teacher_custom_pacing_plans_id;
        const pacingPlans = this.currentLessonPlan?.lesson_plan.pacing_plan_id;
        const combinedPlans = [...(teacherCustomPlans || []), ...(pacingPlans || [])];
        this.combinedPacingPlans = combinedPlans.filter((id) => id);
        // if (teacherCustomPlans?.length > 0) {
        return getMappedData(combinedPlans);
        // }

        // return getMappedData(pacingPlans);
      }

      return this.currentLessonPlan?.lesson_plan?.[key] || '-';
    } catch (err) {}
  }

  async getGradeAndSubject(gradeId: number, subjectId: number) {
    try {
      const subject = await this.subjectService.getSubjectByID(subjectId);
      const grade = await this.gradeService.getGradeByID(gradeId);
      return {
        subject,
        grade,
      };
    } catch (error) {
      // console.log(error);
    }
  }

  async getNewLessonPlan() {
    try {
      if (this.newLessonPlan?.user_id) {
        const teacherLessonPlan: any = await this.lessonPlanService.getTeacherLessonPlanById(
          Number(this.newLessonPlan.id),
        );
        const updatedLessonPlan = await this.updateCurrentLessonPlanEvent(teacherLessonPlan);
        this.alreadyExistEasyQuestions = updatedLessonPlan?.easyQuestions || '';
        this.alreadyExistDifficultQuestions = updatedLessonPlan?.difficultQuestions || '';
        this.attachedDocumentId = updatedLessonPlan.lesson_plan_media_id;

        return updatedLessonPlan.lesson_plan;
      } else {
        return this.lessonPlanService.getLessonPlanById(Number(this.newLessonPlan.id));
      }
    } catch (error) {
      // console.log(error);
    }
  }

  async getLessonPlan() {
    try {
      let lessonPlan;

      if (this.isPacingPlan) {
        lessonPlan = await this.lessonPlanService.getTeacherLessonPlanById(Number(this.lessonPlan.id));
      } else {
        lessonPlan = this.lessonPlan;
      }

      this.getPercentage();

      const updatedLessonPlan = await this.updateCurrentLessonPlanEvent(lessonPlan);
      return updatedLessonPlan;
    } catch (error) {
      // console.log(error);
    }
  }

  // getPercentage() {
  //   if (
  //     new Date(this.lessonPlan.start).toDateString() ===
  //     new Date().toDateString()
  //   ) {
  //     let differenceValue =
  //       (new Date(this.lessonPlan.end).getTime() - new Date().getTime()) / 1000;
  //     differenceValue /= 60;
  //     const result = Math.abs(Math.round(differenceValue));

  //     this.remainingMinute = result;

  //     this.averagePercentage = Math.round(
  //       (new Date(this.lessonPlan.end).getTime() / new Date().getTime()) * 100
  //     );
  //   }
  // }

  getPercentage(): void {
    const now = new Date().getTime();
    const lessonStart = new Date(this.lessonPlan.start).getTime();
    const lessonEnd = new Date(this.lessonPlan.end).getTime();

    if (new Date(this.lessonPlan.start).toDateString() === new Date().toDateString()) {
      // Calculate remaining minutes
      const differenceValue = (lessonEnd - now) / 1000 / 60;
      this.remainingMinute = Math.abs(Math.round(differenceValue));

      // Calculate total lesson duration and time elapsed
      const totalDuration = lessonEnd - lessonStart;
      let elapsedTime = now - lessonStart;

      // Ensure elapsed time is not negative and cap percentage between 0 and 100
      if (elapsedTime > totalDuration) {
        elapsedTime = totalDuration;
      }
      this.averagePercentage = Math.max(0, Math.min(100, Math.round((elapsedTime / totalDuration) * 100)));
    }
  }

  async updateCurrentLessonPlanEvent(lessonPlan) {
    try {
      const lesson_plan = {
        objective: '',
        anticipatory_set: '',
        presentation: '',
        guided_practice_questions: '',
        homework_questions: '',
        closure: '',
        grade: '',
        subject: '',
        section_id: '',
        section_title: '',
        title: '',
        author: '',
        chapter: '',
      };
      if (lessonPlan?.updates?.length) {
        lessonPlan.updates.map((updatedFields) => {
          if (updatedFields.hasOwnProperty('objective')) {
            lessonPlan.lesson_plan_id !== 0
              ? (lessonPlan.lesson_plan.objective = updatedFields.objective)
              : (lesson_plan.objective = updatedFields.objective);
          } else if (updatedFields.hasOwnProperty('anticipatory_set')) {
            lessonPlan.lesson_plan_id !== 0
              ? (lessonPlan.lesson_plan.anticipatory_set = updatedFields.anticipatory_set)
              : (lesson_plan.anticipatory_set = updatedFields.anticipatory_set);
          } else if (updatedFields.hasOwnProperty('presentation')) {
            lessonPlan.lesson_plan_id !== 0
              ? (lessonPlan.lesson_plan.presentation = updatedFields.presentation)
              : (lesson_plan.presentation = updatedFields.presentation);
          } else if (updatedFields.hasOwnProperty('guided_practice_questions')) {
            lessonPlan.lesson_plan_id !== 0
              ? (lessonPlan.lesson_plan.guided_practice_questions = updatedFields.guided_practice_questions)
              : (lesson_plan.guided_practice_questions = updatedFields.guided_practice_questions);
          } else if (updatedFields.hasOwnProperty('homework_questions')) {
            lessonPlan.lesson_plan_id !== 0
              ? (lessonPlan.lesson_plan.homework_questions = updatedFields.homework_questions)
              : (lesson_plan.homework_questions = updatedFields.homework_questions);
          } else if (updatedFields.hasOwnProperty('closure')) {
            lessonPlan.lesson_plan_id !== 0
              ? (lessonPlan.lesson_plan.closure = updatedFields.closure)
              : (lesson_plan.closure = updatedFields.closure);
          } else if (updatedFields.hasOwnProperty('video_urls')) {
            this.router.url.includes('update-lesson-plan')
              ? (lessonPlan.video_urls = updatedFields.video_urls)
              : (lessonPlan.lesson_plan.video_urls = updatedFields.video_urls);
          } else if (updatedFields.hasOwnProperty('lesson_plan_media_id')) {
            lessonPlan.lesson_plan_media_id = updatedFields.lesson_plan_media_id;
          } else if (updatedFields.hasOwnProperty('easyQuestions')) {
            lessonPlan.easyQuestions = updatedFields.easyQuestions?.replace(/(\s*\n\s*){2,}/g, '\n');
          } else if (updatedFields.hasOwnProperty('difficultQuestions')) {
            lessonPlan.difficultQuestions = updatedFields.difficultQuestions?.replace(/(\s*\n\s*){2,}/g, '\n');
          } else if (updatedFields.hasOwnProperty('title')) {
            lessonPlan.lesson_plan_id !== 0
              ? (lessonPlan.lesson_plan.title = updatedFields.title)
              : (lesson_plan.title = updatedFields.title);
          } else if (updatedFields.hasOwnProperty('author')) {
            lessonPlan.lesson_plan_id !== 0
              ? (lessonPlan.lesson_plan.author = updatedFields.author)
              : (lesson_plan.author = updatedFields.author);
          } else if (updatedFields.hasOwnProperty('chapter')) {
            lessonPlan.lesson_plan_id !== 0
              ? (lessonPlan.lesson_plan.chapter = updatedFields.chapter)
              : (lesson_plan.chapter = updatedFields.chapter);
          }

          if (lessonPlan.lesson_plan_id === 0) {
            if (updatedFields.hasOwnProperty('grade')) {
              lesson_plan.grade = updatedFields.grade;
            } else if (updatedFields.hasOwnProperty('subject')) {
              lesson_plan.subject = updatedFields.subject;
            } else if (updatedFields.hasOwnProperty('section_id')) {
              lesson_plan.section_id = updatedFields.section_id;
            } else if (updatedFields.hasOwnProperty('section_title')) {
              lesson_plan.section_title = updatedFields.section_title;
            }
          }
        });
      }
      if (lessonPlan.lesson_plan_id === 0) {
        Object.assign(lessonPlan, { lesson_plan });
      }

      return lessonPlan;
    } catch (error) {}
  }

  async lessonPlanById(id: number) {
    try {
      const data = await this.lessonPlanService.getLessonPlanById(id);
      return data;
    } catch (error) {
      // console.log(error);
    }
  }

  async addPresentationSource() {
    try {
      this.matDialog.open(this.callAPIDialog, {
        width: '500px',
        height: '360px',
      });
    } catch (error) {
      // console.log(error);
    }
  }

  async pickFiles(event) {
    this.spinner.show();
    this.lessonPlanMedia = null;
    this.matDialog.closeAll();
    const fileMe = event.target.files[0];
    const data = new FormData();
    const fileName = fileMe.name.toLowerCase().replace(/ /g, '-');
    data.append('media', fileMe, fileName);

    const lessonPlanMedia: any = await this.lessonPlanService.addLessonPlanMedia(data);
    if (lessonPlanMedia && lessonPlanMedia.id) {
      this.addedMediaFile = true;
      this.storageService.setItem('document', true);
      this.lessonPlanMedia = lessonPlanMedia;
      this.updateLessonPlanMedia();
    }
    this.spinner.hide();
  }

  async updateLessonPlanMedia() {
    try {
      this.lessonPlanMedia.media.safeUrl = this.utilService.getSafeVideoUrl(this.lessonPlanMedia.media.url);
    } catch (error) {
      // console.log(error);
    }
  }

  async addPresentationUrl(): Promise<void> {
    try {
      this.spinner.show();
      const subject: any = await this.subjectService.getSubjectByID(
        this.lessonPlan ? Number(this.lessonPlan.lesson_plan.subject_id) : Number(this.currentLessonPlan.subject_id),
      );

      // Split section titles and section IDs from form values
      const multipleSectionTitles = this.addLessonPlanForm.value.sectionTitle
        .trim() // Trim any extra whitespace at the start or end
        .split('\n') // Split by new lines
        .filter((title) => title.trim() !== ''); // Filter out empty strings

      this.sectionTitles = this.addLessonPlanForm.value.sectionId.split('\n') || [];
      if (this.addVideoUrlsBySection && Object.keys(this.addVideoUrlsBySection).length > 0) {
        this.tempSelectedVideoUrls = [...this.videoUrls];

        const dialogRef = this.matDialog.open(this.viewYouTubeUrl, {
          width: '900px',
          height: '90vh',
          disableClose: true,
        });

        dialogRef.afterClosed().subscribe(() => {
          this.matDialog.closeAll();
        });
        this.spinner.hide();
        return;
        // }
      } else {
        const apiKeys = [
          'AIzaSyAIPvcW5caBYeTJDl1zJkB0X5wSWH-rra0', // primary API key for youtube
        ];

        this.addVideoUrlsBySection = {}; // Object to group videos by section titles
        let apiKeyIndex = 0; // Start with the first API key

        for (let i = 0; i < multipleSectionTitles.length; i++) {
          const body = {
            q: multipleSectionTitles[i] + ' ' + subject.subject,
            maxResults: 10,
            part: 'snippet',
            key: apiKeys[apiKeyIndex],
            type: 'video',
            videoEmbeddable: 'true',
          };

          try {
            const response = await this.lessonPlanService.getYouTubeUrls(body);

            // Store the URLs in the object, grouped by section title
            this.addVideoUrlsBySection[this.sectionTitles[i]] =
              response.items.map((element: any) =>
                this.utilService.getSafeVideoUrl('https://www.youtube-nocookie.com/watch?v=' + element.id.videoId),
              ) || [];

            // Update tempSelectedVideoUrls to reflect the full list
            this.tempSelectedVideoUrls = [...this.addVideoUrlsBySection[this.sectionTitles[i]]];
          } catch (error) {
            // Handle API quotaExceeded error specifically (for error code 403)
            if (error && error.error && (error.error.error.code === 403 || error.error.error.code === 400)) {
              if (apiKeyIndex < apiKeys.length - 1) {
                // If there are more API keys available, switch to the next one
                console.warn('API key quota exceeded, switching to next key');
                apiKeyIndex++; // Move to the next API key
                i--; // Retry the current section with the new API key
              } else {
                // If no API keys left, throw an error indicating all keys have exceeded their quotas
                console.error('All API keys have exceeded their quotas');
                throw error;
              }
            } else {
              // Rethrow other errors
              console.error('Error while fetching YouTube URLs:', error);
              throw error;
            }
          }
        }
        // Update tempSelectedVideoUrls to reflect the full list
        this.tempSelectedVideoUrls = [...this.videoUrls];

        const dialogRef = this.matDialog.open(this.viewYouTubeUrl, {
          width: '900px',
          height: '90vh',
          disableClose: true,
        });

        dialogRef.afterClosed().subscribe(() => {
          this.matDialog.closeAll();
        });

        this.spinner.hide();
      }
    } catch (error) {
      this.spinner.hide();
      console.error('add presentation URL', error);
    }
  }

  async addCustomYouTubeUrl(): Promise<void> {
    try {
      const cleanedUrl = this.convertToDirectYouTubeLink(this.customYouTubeUrl);
      const safeUrl: any = this.utilService.getSafeVideoUrl(cleanedUrl);
      const urls = this.addVideoUrlsBySection[this.activeSection];
      // Check if the URL already exists (compare by URL string)
      const isDuplicate = urls.some(
        (url) => url.changingThisBreaksApplicationSecurity === safeUrl.changingThisBreaksApplicationSecurity,
      );
      if (!isDuplicate) {
        urls.unshift(safeUrl);
      } else {
        this.toasterService.showToast(`This video is already added.`, 'danger');
      }
      this.customYouTubeUrl = '';
    } catch (error) {
      console.log(error);
    }
  }

  // Track the active tab
  onTabChange(event: any): void {
    if (event) {
      this.activeSection = event.tabTitle; // Update the active section based on the tab index
    }
  }

  async checkCurrentLessonPlanRanking() {
    try {
      const params = await this.getRankingBodyParams();
      const response = await this.lessonPlanService.checkCurrentLessonPlanRanking(params);
      if (response && response.length > 0) {
        this.currentRankedPlan = response;
        const filter = this.currentRankedPlan[0].user_id.filter((x) => x === this.user.user.id);
        filter.length > 0 ? (this.isRanked = true) : (this.isRanked = false);
      } else {
        this.currentRankedPlan = [];
        this.isRanked = false;
      }
    } catch (error) {
      // console.log(error);
    }
  }

  async addRank() {
    try {
      const body = await this.getRankingBody();
      const response =
        this.currentRankedPlan && this.currentRankedPlan.length > 0
          ? await this.lessonPlanService.updateLessonPlanRankings(this.currentRankedPlan[0].id, body)
          : await this.lessonPlanService.addRankToLessonPlan(body);

      if (response && response.id) {
        await this.checkCurrentLessonPlanRanking();
      }
    } catch (error) {
      // console.log(error);
    }
  }

  async getRankingBody() {
    try {
      let body;

      const lessonPlan = this.newLessonPlan ? this.newLessonPlan : this.lessonPlan;
      const isLessonPlan = lessonPlan && lessonPlan.user_id ? true : false;

      if (this.currentRankedPlan && this.currentRankedPlan.length > 0) {
        this.currentRankedPlan[0].user_id.push(this.user.user.id);
        body = {
          lesson_plan_id: this.currentRankedPlan[0].lesson_plan_id,
          teacher_lesson_plan_id: this.currentRankedPlan[0].teacher_lesson_plan_id,
          user_id: this.currentRankedPlan[0].user_id,
          ranking_points: this.currentRankedPlan[0].ranking_points + 1,
        };
      } else {
        body = {
          lesson_plan_id: isLessonPlan ? null : lessonPlan.id,
          teacher_lesson_plan_id: isLessonPlan ? lessonPlan.id : null,
          user_id: [this.user.user.id],
          ranking_points: 2,
        };
      }
      return body;
    } catch (error) {
      // console.log(error);
    }
  }

  async getRankingBodyParams() {
    try {
      let body;
      if (this.newLessonPlan) {
        if (this.newLessonPlan && this.newLessonPlan.user_id) {
          body = {
            teacher_lesson_plan_id: this.newLessonPlan.id,
          };
        } else {
          body = {
            lesson_plan_id: this.newLessonPlan.id,
          };
        }
      } else {
        body = {
          teacher_lesson_plan_id: this.currentLessonPlan.id,
        };
      }

      return body;
    } catch (error) {
      // console.log(error);
    }
  }

  async addRankToLessonPlan() {
    try {
      if (this.isRanked) {
        this.isRanked = false;
        await this.deleteRank();
      } else {
        this.isRanked = true;
        await this.addRank();

        if (this.newLessonPlan && this.newLessonPlan.user_id && this.newLessonPlan.user_id !== this.user.user.id) {
          await this.setPowerUpPoints(10);
        }
      }
    } catch (error) {
      // console.log(error);
    }
  }

  async setPowerUpPoints(points: number) {
    try {
      const powerUpPoints = await this.authService.getPowerUpPointsByUserId({
        user_id: points === 20 ? this.user.user.id : this.newLessonPlan.user_id,
      });

      if (powerUpPoints && powerUpPoints.length > 0) {
        this.updatePowerUpPoints(powerUpPoints, points);
      } else {
        this.addPowerUpPoints(points);
      }
    } catch (error) {
      // console.log(error);
    }
  }

  async updatePowerUpPoints(previousPoints, points: number) {
    try {
      const newPoints = previousPoints[0].points;

      newPoints.push({
        points: points,
        type: points === 20 ? 1 : 2,
      });

      await this.authService.updatePowerUpPoints(previousPoints[0].id, {
        user_id: points === 20 ? this.user.user.id : this.newLessonPlan.user_id,
        points: newPoints,
        school_id: previousPoints[0].school_id,
        role_id: previousPoints[0].role_id,
      });
    } catch (error) {
      // console.log(error);
    }
  }

  async addPowerUpPoints(points: number) {
    try {
      const user: any = await this.storageService.getItem('user');
      await this.authService.addPowerUpPoints({
        user_id: points === 20 ? this.user.user.id : this.newLessonPlan.user_id,
        points: [
          {
            points: points,
            type: points === 20 ? 1 : 2,
          },
        ],
        school_id: user.user.school_id,
        role_id: user.user.role_id,
      });
    } catch (error) {
      // console.log(error);
    }
  }

  async deleteRank() {
    try {
      this.currentRankedPlan[0].user_id.splice(this.currentRankedPlan[0].user_id.indexOf(this.user.user.id), 1);
      const body = {
        lesson_plan_rankings_id: this.currentRankedPlan[0].id,
        lesson_plan_id: this.currentRankedPlan[0].lesson_plan_id,
        teacher_lesson_plan_id: this.currentRankedPlan[0].teacher_lesson_plan_id,
        user_id: this.currentRankedPlan[0].user_id,
        ranking_points: 1,
      };
      await this.lessonPlanService.updateLessonPlanRankings(this.currentRankedPlan[0].id, body);
      await this.checkCurrentLessonPlanRanking();
    } catch (error) {
      // console.log(error);
    }
  }

  async setCounter() {
    try {
      this.interval = setInterval(() => {
        const x = dayjs(Number(this.lessonPlan.end));
        const y = dayjs();

        this.remainingTime = dayjs.duration(x.diff(y));
        this.getPercentage();
      }, 1000);
    } catch (error) {
      // console.log(error);
    }
  }

  async getFormControls() {
    try {
      this.addLessonPlanForm = this.fb.group({
        start: ['', Validators.required],
        end: ['', Validators.required],
        objective: ['', Validators.required],
        anticipatory_set: ['', Validators.required],
        presentation: ['', Validators.required],
        guided_practice_questions: ['', Validators.required],
        homework_questions: ['', Validators.required],
        closure: ['', Validators.required],
        sectionId: [''],
        sectionTitle: [''],
        you_tube_url: [''],
        easyQuestions: [''],
        difficultQuestions: [''],
        subject: [''],
        grade: [''],
      });

      this.lessonPlanForm = this.fb.group({
        title: ['', Validators.required, validateNoWhitespace],
        author: ['', Validators.required, validateNoWhitespace],
        chapter: [''],
      });

      this.englishlessonPlanForm = this.fb.group({
        objective: ['', Validators.required],
        anticipatory_set: ['', Validators.required],
        presentation: ['', Validators.required],
        guided_practice_questions: ['', Validators.required],
        homework_questions: ['', Validators.required],
        closure: ['', Validators.required],
        start: ['', Validators.required],
        end: ['', Validators.required],
      });

      this.youtubeUrlForm = this.fb.group({
        customYouTubeUrl: ['', [Validators.required, this.youtubeUrlValidator]],
      });
    } catch (error) {
      // console.log(error);
    }
  }

  youtubeUrlValidator(control: AbstractControl): ValidationErrors | null {
    try {
      const youtubeUrlPattern = /^(https?\:\/\/)?(www\.youtube\.com|youtu\.be)\/.+$/;
      if (!control.value || youtubeUrlPattern.test(control.value)) {
        return null;
      }
      return { youtubeUrl: true };
    } catch (error) {
      // console.log(error);
    }
  }

  async closeDialog() {
    try {
      this.closeExpandViewModal.emit();
    } catch (error) {
      // console.log(error);
    }
  }

  async deleteTeacherLessonPlans() {
    try {
      const body = {
        lessonPlanIds: this.existedLessonPlanIds,
      };
      await this.lessonPlanService.deleteMultipleTeacherLessonPlans(body);
    } catch (error) {
      // console.log(error);
    }
  }

  async openLessonPlanPrivacyDialog(isSet = false) {
    try {
      if (isSet) {
        // check if versions are present for the selected lesson plan
        this.showLessonPlanSpinner = true;
        this.spinner.show();
        // if (!this.isAIGeneratedPlan) {
        const lessonPlanVersionsExists = await this.getTeacherLessonPlans();
        //show error if more than 10 surveys are existed
        if (lessonPlanVersionsExists.length > 10) {
          this.spinner.hide();
          this.showLessonPlanSpinner = false;
          const selectedPrivacyOption = this.privacyOptions.filter((option) => option.value === this.privacyOption);
          this.toasterService.showToast(
            `You cannot save the lesson plan with the ${selectedPrivacyOption[0].name} privacy option because more than 10 versions already exist. Please choose a different privacy option.`,
            'danger',
          );
          return;
        }
        // }
        //delete existing lesson plan changes
        this.deleteTeacherLessonPlans();
        await this.setLessonPlan(true);
        this.spinner.hide();
        this.showLessonPlanSpinner = false;
      } else {
        this.dialogRef = this.dialogService.open(this.lessonPlanPrivacyDialog);
      }
    } catch (error) {
      this.showLessonPlanSpinner = false;
      console.log(error);
    }
  }

  async setLessonPlan(setPrivacyOption = false): Promise<void> {
    try {
      this.spinner.show();
      let response;

      if (this.newLessonPlan || this.pushLessonPlan) {
        const teacherLessonPlanBody = await this.getNewLessonPlanBody(false, setPrivacyOption);
        // this.checkForMediaFileWarning(teacherLessonPlanBody, false);
        response = await this.lessonPlanService.addTeacherLessonPlan(teacherLessonPlanBody);
      } else {
        const body = await this.getCurrentLessonPlanBody(setPrivacyOption);
        // this.checkForMediaFileWarning(body, false);
        response = await this.lessonPlanService.updateTeacherLessonPlan(this.lessonPlan.id, body);
      }
      // add lesson plan reference
      const body = {
        lesson_plan_id: this.baseLessonPlanId,
        school_id: this.user?.user?.school_id,
        teacher_lesson_plan_id: this.selectedLessonPlanId,
        user_id: this.user.user.id,
        classroom_id: this.classroomId,
      };

      // send the congratulations email after first lesson plan setup
      // const isExists = {
      //   user_id: this.user.user.id,
      // };

      // if (this.user.user.isFirstClassroomMailSent) {
      // } else {
      //   if (this.isTeacherOnly) {
      //     const lessonPlanExists = await this.lessonPlanService.checkIfLessonPlanExists(isExists);
      //     if (lessonPlanExists.length > 0) {
      //       await this.sendMailAfterFirstClassroomSetup(this.user.user);
      //       const body = {
      //         ...this.user.user,
      //         isFirstClassroomMailSent: true,
      //       };

      //       const updateUser = await this.authService.updateUser(this.user.user.id, body, true);
      //       if (updateUser) {
      //         const storageData = await this.storageService.getItem('user');
      //         this.storageService.removeItem('user');
      //         storageData.user = updateUser;
      //         this.storageService.setItem('user', storageData);
      //         this.authService.updateValue.next(true);
      //       }
      //     }
      //   }
      // }

      if (response && response.id) {
        // add ranking to the lesson plan
        await this.addRankToTeacherLessonPlan(body);
        this.selectedLessonPlanId = response.id;
        const checkIfRecordExists = await this.lessonPlanService.getTeacherLessonPlanRankings(body);
        if (checkIfRecordExists?.id > 0) {
          if (!this.isAIGeneratedPlan) {
            body['privacy_option'] = this.privacyOption;
            await this.lessonPlanService.updateTeacherLessonPlanRanking(checkIfRecordExists.id, body);
          }
        } else {
          if (!this.isAIGeneratedPlan) {
            body['privacy_option'] = this.privacyOption;
            await this.lessonPlanService.addTeacherLessonPlanRanking(body);
          }
        }
      }
      this.isCreateAssignment ? await this.createAssignmentAndRender(response?.id) : this.renderAfterEvent();
      this.spinner.hide();

      if (this.newLessonPlan && this.newLessonPlan.user_id && this.newLessonPlan.user_id !== this.user.user.id) {
        await this.setPowerUpPoints(20);
      }
      await this.addQuestionsToDatabase(this.selectedQuestionType, this.generatedQuestions);
      this.storageService.removeItem('easy_questions');
      this.storageService.removeItem('difficult_questions');
    } catch (error) {
      this.spinner.hide();
      console.log(error);
    }
  }

  renderAfterEvent() {
    try {
      if (this.dialogRef) this.dialogRef.close();
      this.pacingPlanService.view = 'Day';
      this.calendarService.viewDate = this.route?.snapshot?.queryParams?.currentDate
        ? new Date(Number(this.route?.snapshot?.queryParams?.currentDate))
        : this.newLessonPlan
          ? new Date(this.newLessonPlan?.start)
          : new Date(Number(this.lessonPlan?.start));
      if (this.classroomId) {
        this.router.navigate(['/test-quizzes/classroom-details', this.classroomId]);
      } else {
        this.router.navigate(['/pacing-lesson-plan']);
      }

      this.pacingPlanService.isLessonPan.next(true);
      this.pacingPlanService.removeObservers();
    } catch (error) {
      // console.log(error);
    }
  }

  async getCurrentLessonPlanBody(privacyOption = false) {
    try {
      const updates = await this.getUpdatedFields();
      const body = {
        start: this.lessonPlan.start,
        end: this.lessonPlan.end,
        user_id: this.lessonPlan.user_id,
        school_id: this.lessonPlan.school_id,
        lesson_plan_id: this.lessonPlan.lesson_plan_id,
        teacher_lesson_plan_id: this.lessonPlan.id,
        updates: updates,
        subject_id: this.lessonPlan.subject_id,
        grades_id: this.lessonPlan.grades_id,
        teacher_lesson_plan_privacy_id: privacyOption
          ? this.privacyOption
          : this.lessonPlan?.teacher_lesson_plan_privacy_id,
        classroom_id: this.lessonPlan?.classroom_id,
        substitute_teacher_user_id: this.lessonPlan?.substitute_teacher_user_id
          ? this.lessonPlan?.substitute_teacher_user_id
          : null,
      };
      return body;
    } catch (error) {
      // console.log(error);
    }
  }

  async setCurrentDateHoursAndMinutes(selectedDate: Date) {
    try {
      const date = new Date(
        this.route?.snapshot?.queryParams?.currentDate
          ? Number(this.route?.snapshot?.queryParams?.currentDate)
          : this.currentLessonPlan.start,
      ).setHours(
        selectedDate.getHours(),
        selectedDate.getMinutes(),
        selectedDate.getSeconds(),
        selectedDate.getMilliseconds(),
      );

      return date;
    } catch (error) {
      // console.log(error);
    }
  }

  async getNewLessonPlanBody(isUpdate = false, setPrivacyOption = false) {
    try {
      let subjectHours: any = [];

      if (this.currentClassroom?.extras['eventDates']?.length > 0) {
        // for teacher only multi subjects classrooms
        if (this.currentClassroom.subject_id.length > 1 && !this.isTeacherOnly) {
          if (this.currentClassroom.createdDuringTeacherOnly) {
            subjectHours = this.currentClassroom.extras['eventDates'].filter(
              (x) =>
                x.day ===
                this.utilService
                  .getWeekDayString(
                    new Date(
                      this.route?.snapshot?.queryParams?.currentDate
                        ? Number(this.route?.snapshot?.queryParams?.currentDate)
                        : isUpdate
                          ? this.currentLessonPlan.lesson_plan.start
                          : this.currentLessonPlan.start,
                    ).getDay(),
                  )
                  .toLowerCase(),
            );
          } else {
            // added for multiple classroom
            subjectHours = this.currentClassroom.extras['eventDates'].filter(
              (x) =>
                x.day ===
                  this.utilService
                    .getWeekDayString(
                      new Date(
                        this.route?.snapshot?.queryParams?.currentDate
                          ? Number(this.route?.snapshot?.queryParams?.currentDate)
                          : isUpdate
                            ? this.currentLessonPlan.lesson_plan.start
                            : this.currentLessonPlan.start,
                      ).getDay(),
                    )
                    .toLowerCase() && x.subject_id === this.currentLessonPlan.subject_id,
            );
          }
        } else {
          // handled the timing issue for multi-subject classroom
          if (this.currentClassroom.createdDuringTeacherOnly && this.currentClassroom.subject_id.length > 1) {
            const subjectHoursData = this.currentClassroom.extras['eventDates'].filter(
              (x) =>
                x.day ===
                this.utilService
                  .getWeekDayString(
                    new Date(
                      this.route?.snapshot?.queryParams?.currentDate
                        ? Number(this.route?.snapshot?.queryParams?.currentDate)
                        : isUpdate
                          ? this.currentLessonPlan.lesson_plan.start
                          : this.currentLessonPlan.start,
                    ).getDay(),
                  )
                  .toLowerCase(),
            );
            subjectHours = subjectHoursData.filter((x) => {
              return (
                Number(x.subjectId) ===
                Number(
                  isUpdate
                    ? this.currentLessonPlan.lesson_plan.pacing_plan.subject_id
                    : this.currentLessonPlan.pacing_plan_id.length > 0 &&
                        this.currentLessonPlan.pacing_plan_id[0] !== null
                      ? this.currentLessonPlan.pacing_plan_id[0]?.subject_id
                      : this.currentLessonPlan.teacher_custom_pacing_plans_id[0].subject_id,
                )
              );
            });
          } else {
            subjectHours = this.currentClassroom.extras['eventDates'].filter(
              (x) =>
                x.day ===
                this.utilService
                  .getWeekDayString(
                    new Date(
                      this.route?.snapshot?.queryParams?.currentDate
                        ? Number(this.route?.snapshot?.queryParams?.currentDate)
                        : isUpdate
                          ? this.currentLessonPlan.lesson_plan.start
                          : this.currentLessonPlan.start,
                    ).getDay(),
                  )
                  .toLowerCase(),
            );
          }
        }
      }

      if (subjectHours?.length === 0) {
        const subjectHoursBody = {
          user_id: this.currentClassroom?.user_id ? this.currentClassroom?.user_id : this.user.user.id,
          subject_id: isUpdate
            ? this.currentLessonPlan.lesson_plan.pacing_plan.subject_id
            : this.currentLessonPlan.pacing_plan_id.length > 0 && this.currentLessonPlan.pacing_plan_id[0] !== null
              ? this.currentLessonPlan.pacing_plan_id[0]?.subject_id
              : this.currentLessonPlan.teacher_custom_pacing_plans_id[0].subject_id,
          grade_id: isUpdate
            ? this.currentLessonPlan.lesson_plan.pacing_plan.grades_id
            : this.currentLessonPlan.pacing_plan_id.length > 0 && this.currentLessonPlan.pacing_plan_id[0] !== null
              ? this.currentLessonPlan.pacing_plan_id[0].grades_id
              : this.currentLessonPlan.teacher_custom_pacing_plans_id[0].grades_id,
          day: this.utilService
            .getWeekDayString(
              new Date(
                this.route?.snapshot?.queryParams?.currentDate
                  ? Number(this.route?.snapshot?.queryParams?.currentDate)
                  : isUpdate
                    ? this.currentLessonPlan.lesson_plan.start
                    : this.currentLessonPlan.start,
              ).getDay(),
            )
            .toLowerCase(),
        };
        if (this.user?.user?.teachingInfo?.schoolBellScheduleId && this.currentClassroom?.user_id === this.user.user.id)
          subjectHoursBody['school_bell_shedules_id'] = this.user?.user?.teachingInfo?.schoolBellScheduleId;

        if (this.user.user.is_trial_user) {
          subjectHoursBody['user_id'] = this.user?.user?.teachingInfo?.dummyUserId;
        }

        subjectHours = await this.teacherLessonPlanService.getTeacherSubjectHours(
          subjectHoursBody,
          this.user.user.is_trial_user ? true : false,
        );
      }

      const startDate = await this.setCurrentDateHoursAndMinutes(new Date(subjectHours[0]?.start));
      const endDate = await this.setCurrentDateHoursAndMinutes(new Date(subjectHours[0]?.end));
      const currentClassroomSubject = this.storageService.getItem('currentClassroomSubject') || 0;

      const updates = await this.getUpdatedFields();
      const body = {
        start: new Date(startDate).getTime(),
        end: new Date(endDate).getTime(),
        user_id: this.user.user.is_trial_user
          ? this.user.user.id
          : this.currentClassroom?.user_id
            ? this.currentClassroom?.user_id
            : this.user.user.id,
        school_id: this.user.user.school_id,
        lesson_plan_id: isUpdate ? this.currentLessonPlan.lesson_plan_id : this.currentLessonPlan.id,
        updates: updates,
        subject_id: isUpdate
          ? this.currentLessonPlan.lesson_plan.pacing_plan.subject_id
          : this.currentLessonPlan.pacing_plan_id.length > 0
            ? currentClassroomSubject.id
            : this.currentLessonPlan.teacher_custom_pacing_plans_id.length > 0
              ? this.currentLessonPlan.teacher_custom_pacing_plans_id[0].subject_id
              : this.currentLessonPlan.custom_global_pacing_plan.subject_id,
        grades_id: isUpdate
          ? this.currentLessonPlan.lesson_plan.pacing_plan.grades_id
          : this.currentLessonPlan.pacing_plan_id.length > 0
            ? this.currentLessonPlan.pacing_plan_id[0].grades_id
            : this.currentLessonPlan.teacher_custom_pacing_plans_id.length > 0
              ? this.currentLessonPlan.teacher_custom_pacing_plans_id[0].grades_id
              : this.currentLessonPlan.custom_global_pacing_plan.grades_id,
        teacher_lesson_plan_privacy_id: setPrivacyOption ? this.privacyOption : 1,
        classroom_id: this.classroomId,
      };
      if (this.currentClassroom.is_dummy) {
        body['is_dummy'] = true;
      }

      if (!this.user.user.is_trial_user && this.currentClassroom?.user_id !== this.user.user.id) {
        body['substitute_teacher_user_id'] = this.user.user.id;
      }
      return body;
    } catch (error) {
      console.log('getNewLessonPlanBody', error);
    }
  }

  async getUpdatedFields() {
    try {
      const videoUrls = await this.getUpdatedVideoUrls();
      const newUpdatedFields = [];
      const isEnglishLessonPlan = this.localStorageService.getItem('englishStoryData');
      this.isEnglishLessonPlan = isEnglishLessonPlan;
      newUpdatedFields.push(
        {
          objective: this.addLessonPlanForm.value.objective,
        },
        {
          anticipatory_set: this.addLessonPlanForm.value.anticipatory_set,
        },
        {
          presentation: this.addLessonPlanForm.value.presentation,
        },
        {
          guided_practice_questions: this.addLessonPlanForm.value.guided_practice_questions,
        },
        {
          homework_questions: this.addLessonPlanForm.value.homework_questions,
        },
        {
          closure: this.addLessonPlanForm.value.closure,
        },
        {
          lesson_plan_media_id: this.lessonPlanMedia && this.lessonPlanMedia.id ? this.lessonPlanMedia.id : null,
        },
        {
          video_urls: videoUrls,
        },
        {
          easyQuestions: this.addLessonPlanForm.value.easyQuestions,
        },
        {
          difficultQuestions: this.addLessonPlanForm.value.difficultQuestions,
        },
      );
      if (this.isEnglishLessonPlan) {
        newUpdatedFields.push(
          {
            title:
              isEnglishLessonPlan && isEnglishLessonPlan !== null
                ? isEnglishLessonPlan.title
                : this.lessonPlanForm?.value?.title,
          },
          {
            author:
              isEnglishLessonPlan && isEnglishLessonPlan !== null
                ? isEnglishLessonPlan.author
                : this.lessonPlanForm?.value?.author,
          },
        );
      }
      if (this.isEnglishLessonPlan) {
        newUpdatedFields.push({
          chapter:
            isEnglishLessonPlan && isEnglishLessonPlan !== null
              ? isEnglishLessonPlan.chapter
              : this.lessonPlanForm?.value?.chapter,
        });
      }
      return newUpdatedFields;
    } catch (error) {
      // console.log(error);
    }
  }

  async getUpdatedVideoUrls() {
    try {
      const newUrls = [];
      this.videoUrls.map((x) => {
        newUrls.push(this.utilService.getSafeVideoUrl(x.changingThisBreaksApplicationSecurity, false));
      });
      return newUrls;
    } catch (error) {
      // console.log(error);
    }
  }

  async updateYouTubeUrls() {
    try {
      return this.utilService.youTubeUrls(this.currentLessonPlan.video_urls);
    } catch (error) {
      // console.log(error);
    }
  }

  async addLessonPlan(data: Object) {
    try {
      const response = await this.lessonPlanService.addLessonPlan(data);
      if (response && response.id) {
        this.renderAfterEvent();
      }
    } catch (error) {
      // console.log(error);
    }
  }

  async deleteLessonPlanDialog(dialog) {
    try {
      this.spinner.show();
      this.isSave = true;
      this.openLessonPlanDialog(dialog, true);

      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      // console.log(error);
    }
  }

  async openLessonPlanDialog(dialog, isDelete = false) {
    try {
      isDelete
        ? (this.dialogRef = this.dialogService.open(dialog))
        : this.addLessonPlanForm.dirty || this.isValidSources
          ? (this.dialogRef = this.dialogService.open(dialog))
          : await this.setLessonPlan();
    } catch (error) {
      // console.log(error);
    }
  }

  async deleteLessonPlan() {
    try {
      this.spinner.show();

      await this.lessonPlanService.deleteTeacherLessonPlan(Number(this.lessonPlan.id));
      if (this.isPacingPlan) {
        this.renderAfterEvent();
      } else {
        await this.closeDialog();
      }
      this.spinner.hide();
    } catch (error) {
      // console.log(error);
      this.spinner.hide();
    }
  }

  deleteYouTubeSourceUrls(index: number) {
    try {
      this.isValidSources = true;
      const videoUrl = this.videoUrls[index];
      const newUrl = this.utilService.getSafeVideoUrl(videoUrl.changingThisBreaksApplicationSecurity, false);
      this.videoUrls.splice(this.videoUrls.indexOf(videoUrl), 1);
      this.lessonPlan
        ? this.lessonPlan?.video_urls?.splice(this.lessonPlan.video_urls.indexOf(newUrl), 1)
        : this.newLessonPlan?.video_urls?.splice(this.newLessonPlan.video_urls.indexOf(newUrl), 1);
    } catch (error) {
      // console.log(error);
    }
  }

  deleteLessonPlanMedia() {
    this.lessonPlanMedia = null;
    this.storageService.removeItem('document');
  }

  viewYouTubeSourceUrl(videoUrl) {
    try {
      this.youTubeUrl = videoUrl;
      const dialogRef = this.matDialog.open(this.viewYouTubeUrl, {
        width: '700px',
        height: '600px',
        disableClose: true,
      });
      dialogRef.afterClosed().subscribe(() => {});
    } catch (error) {
      // console.log(error);
    }
  }

  async addNewPresentation() {
    try {
      this.spinner.show();
      this.highlightPresentation = false;
      if (!this.utilService.checkIfTokenLimitExceededAndCreditsOut(this.userAccessAIToken, this.user?.user)) {
        // } else {
        const subjectId = this.lessonPlan
          ? this.lessonPlan.lesson_plan.pacing_plan_id.length > 0
            ? this.lessonPlan.lesson_plan.pacing_plan_id[0].subject_id
            : this.lessonPlan.lesson_plan.teacher_custom_pacing_plans_id[0].subject_id
          : this.newLessonPlan.user_id
            ? this.newLessonPlan.lesson_plan.pacing_plan_id.length > 0
              ? this.newLessonPlan.lesson_plan.pacing_plan_id[0].subject_id
              : this.newLessonPlan.lesson_plan.teacher_custom_pacing_plans_id[0].subject_id
            : this.newLessonPlan.subject_id;
        const subject: any = await this.subjectService.getSubjectByID(subjectId);
        let response;

        if (this.lessonPlanForm.value.title !== '' && this.lessonPlanForm.value.author !== '') {
          const multipleSectionTitles = this.addLessonPlanForm?.value?.sectionTitle?.split('\n')?.join('and ');
          const prompt = `Create a detailed 5-10 minute presentation for teacher to teach the English standard "${multipleSectionTitles}" based on the story "${
            this.lessonPlanForm.value.title
          }" by "${this.lessonPlanForm.value.author}" on Chapter  ${
            this.lessonPlanForm.value.chapter !== '' ? `on Chapter "${this.lessonPlanForm.value.chapter}"` : ''
          }  to students.`;
          // response = await this.OpenAiAssistant.createThreadEnglishLessonPlanPresentation(prompt);
          response = await this.startStream(prompt); //generate the streaming response for the novel based lesson plan's presentation
        } else {
          const multipleSectionTitles = this.addLessonPlanForm.value?.sectionTitle?.split('\n')?.join('and ');
          const prompt = `Create a detailed 5-10 minute presentation for teacher to teach the
           ${subject.subject} standard "${multipleSectionTitles}" to students without adding extra information texts and notes`;
          // response = await this.openAiService.openAIEncryptionGenerateQuestions(
          //   prompt
          // );

          response = await this.startStream(prompt);
        }

        await this.checkForUserAccessAITokenUpdate(this.user?.user, this.userAccessAIToken);

        if (response) {
          this.isValidSources = true;
          // this.addLessonPlanForm.patchValue({
          //   presentation:
          //     this.lessonPlanForm.value.title !== '' && this.lessonPlanForm.value.author !== ''
          //       ? response?.data?.response.replace(/\*\*(.*?)\*\*/g, '$1').trim()
          //       : response.data.content.replace(/- \*\*|\*\*|##|---/g, '').trim(),
          // });

          // const presentationValue =
          //   this.lessonPlanForm.value.title !== '' &&
          //   this.lessonPlanForm.value.author !== ''
          //     ? response?.data?.response.replace(/\*\*(.*?)\*\*/g, '$1').trim()
          //     : response.data.content.replace(/- \*\*|\*\*|##|---/g, '').trim();

          // Set full text for animation
          // this.fullText = presentationValue;
          // this.addLessonPlanForm.patchValue({
          //   presentation: this.fullText // Initially set the value
          // });

          // Start the typing animation
          // this.typeText();
        }
      }
      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      console.log('addNewPresentation', error);
    }
  }
  async startStream(prompt: string) {
    if (this.presentationStreamSub) {
      this.presentationStreamSub.unsubscribe();
    }

    let index = 0;
    this.presentationStreamSub = (await this.openAiService.streamCompletion(gptModel.gpt_4, prompt)).subscribe(
      (data) => {
        // Append the new data to the existing content
        this.addLessonPlanForm.patchValue({
          presentation: index === 0 ? data : this.addLessonPlanForm.value.presentation + data,
        });
        index++;
      },
      (error) => {
        console.error('Error receiving stream:', error);
      },
      () => {
        console.log('Streaming complete');
      },
    );
  }

  addYouTubeUrl(url: SafeResourceUrl) {
    try {
      // Convert SafeResourceUrl to string for comparison
      const urlString = url['changingThisBreaksApplicationSecurity'];
      const index = this.tempSelectedVideoUrls.findIndex(
        (v: any) => v['changingThisBreaksApplicationSecurity'] === urlString,
      );

      if (index !== -1) {
        // URL already exists, then show toast
        this.toasterService.showToast(`This video is already in the list. You can't add it again.`, 'danger');
      } else {
        // Add new URL
        this.tempSelectedVideoUrls.push(url);
      }
    } catch (error) {
      console.error('Error in addYouTubeUrl:', error);
    }
  }

  async addPracticeQuestions(type: string) {
    try {
      this.spinner.show();
      this.selectedQuestionType = type;
      if (!this.utilService.checkIfTokenLimitExceededAndCreditsOut(this.userAccessAIToken, this.user?.user)) {
        const firstQuestion = this.addLessonPlanForm.value.guided_practice_questions.substring(
          this.addLessonPlanForm.value.guided_practice_questions.toLowerCase().indexOf('1.') + 3,
          this.addLessonPlanForm.value.guided_practice_questions.toLowerCase().indexOf('2.') - 1,
        );
        let response;

        if (this.lessonPlanForm.value.title !== '' && this.lessonPlanForm.value.author !== '') {
          const prompt =
            type === 'easy'
              ? `Generate 5 new questions similiar to ${firstQuestion} based on the story "${this.lessonPlanForm.value.title}" by "${
                  this.lessonPlanForm.value.author
                }" ${this.lessonPlanForm.value.chapter !== '' ? `and its chapter "${this.lessonPlanForm.value.chapter}"` : ''}`
              : `Generate 5 new questions,  that are slightly more difficult than ${firstQuestion} based on the story "${
                  this.lessonPlanForm.value.title
                }" by "${this.lessonPlanForm.value.author}" ${
                  this.lessonPlanForm.value.chapter !== ''
                    ? `and its chapter "${this.lessonPlanForm.value.chapter}"`
                    : ''
                }`;

          response = await this.OpenAiAssistant.createThreadEnglishLessonPlanQuestions(prompt);
        } else {
          const prompt =
            type === 'easy'
              ? `Generate 5 new questions without solutions similiar to ${firstQuestion} and only output the questions and nothing else.`
              : `Generate 5 new questions, without solutions, that are slightly more difficult than ${firstQuestion} and only output the questions and nothing else.`;
          response = await this.openAiService.openAIEncryptionGenerateQuestions(prompt);
        }

        if (response) {
          this.isValidSources = true;
          this.lessonPlanForm.value.title !== '' && this.lessonPlanForm.value.author !== ''
            ? this.patchQuestions(response?.data?.response, type)
            : this.patchQuestions(response?.data?.content, type);
        }

        await this.checkForUserAccessAITokenUpdate(this.user?.user, this.userAccessAIToken);
        this.spinner.hide();

        //original changes
        // this.lessonPlanForm.value.title !== '' && this.lessonPlanForm.value.author !== ''
        //   ? await this.addQuestionsToDatabase(type, response?.data?.response)
        //   : await this.addQuestionsToDatabase(type, response?.data?.content);
      }
      this.spinner.hide();
    } catch (error) {
      // console.log(error)
      this.spinner.hide();
    }
  }

  async addQuestionsToDatabase(type: string, questions: string) {
    try {
      const body = {
        global_pacing_plan_id: this.newLessonPlan
          ? this.newLessonPlan.user_id
            ? this.newLessonPlan.lesson_plan.pacing_plan_id
            : this.newLessonPlan.pacing_plan_id
          : this.lessonPlan.lesson_plan.pacing_plan_id,
        teacher_custom_pacing_plans_id: this.newLessonPlan
          ? this.newLessonPlan.user_id
            ? this.newLessonPlan.lesson_plan.teacher_custom_pacing_plans_id
            : this.newLessonPlan.teacher_custom_pacing_plans_id
          : this.lessonPlan.lesson_plan.teacher_custom_pacing_plans_id,
        // questions: questions?.trim(),
      };

      const easyQuestion = this.storageService.getItem('easy_questions');
      if (easyQuestion) {
        body['questions'] = easyQuestion;
        const easyQuestionsRes: any = await this.pacingPlanService.addEasyQuestionsToDatabase(body);
        this.easyQuestionsInDatabase.push(easyQuestionsRes?.id);
      }

      const difficultQuestion = this.storageService.getItem('difficult_questions');
      if (difficultQuestion) {
        body['questions'] = difficultQuestion;
        const difficultQuestionRes: any = await this.pacingPlanService.addDifficultQuestionsToDatabase(body);
        this.difficultQuestionsInDatabase.push(difficultQuestionRes?.id);
      }
    } catch (error) {
      console.log(error);
    }
  }

  patchQuestions(response: string, type: string) {
    this.generatedQuestions = response;
    type === 'easy'
      ? this.addLessonPlanForm.patchValue({
          easyQuestions: response.trim()?.replace(/(\s*\n\s*){2,}/g, '\n'),
        })
      : this.addLessonPlanForm.patchValue({
          difficultQuestions: response.trim()?.replace(/(\s*\n\s*){2,}/g, '\n'),
        });
    // store easy and difficult questions on localStorage
    this.storageService.setItem(type === 'easy' ? 'easy_questions' : 'difficult_questions', response);
  }

  async createNewAssignment(dialog) {
    try {
      if (dialog) {
        this.isSave = false;
        this.dialogRef = this.dialogService.open(dialog);
      } else {
        this.spinner.show();
        this.storageService.removeItem('homeworkAssignmentQuestions');
        this.isCreateAssignment = true;
        let lessonPlanRes;
        if (this.newLessonPlan) {
          const response = await this.getLessonPlanIfExist();

          response && response.length > 0
            ? (this.dialogRef = this.dialogService.open(this.newLessonPlanContent))
            : this.openLessonPlanPrivacyDialog();
        } else {
          const body = await this.getCurrentLessonPlanBody();
          lessonPlanRes = await this.lessonPlanService.updateTeacherLessonPlan(this.lessonPlan.id, body);
          await this.createAssignmentAndRender(lessonPlanRes?.id);
        }

        this.spinner.hide();
      }
    } catch (error) {
      console.log(error);
      this.spinner.hide();
    }
  }

  async createAssignmentAndRender(lessonPlanId: number) {
    try {
      const body = {
        title: this.lessonPlan
          ? [
              ...(this.lessonPlan.lesson_plan.pacing_plan_id?.length > 0
                ? this.lessonPlan.lesson_plan.pacing_plan_id
                    .filter((plan: any) => plan !== null)
                    .map((plan: any) => plan.section_title)
                : []),
              ...(this.lessonPlan.lesson_plan.teacher_custom_pacing_plans_id?.length > 0
                ? this.lessonPlan.lesson_plan.teacher_custom_pacing_plans_id
                    .filter((plan: any) => plan !== null)
                    .map((plan: any) => plan.section_title)
                : []),
            ]
              .filter((title) => title)
              .join(', ')
          : this.newLessonPlan.user_id
            ? [
                ...(this.newLessonPlan.lesson_plan.pacing_plan_id?.length > 0
                  ? this.newLessonPlan.lesson_plan.pacing_plan_id
                      .filter((plan: any) => plan !== null)
                      .map((plan: any) => plan.section_title)
                  : []),
                ...(this.newLessonPlan.teacher_custom_pacing_plans_id?.length > 0
                  ? this.newLessonPlan.teacher_custom_pacing_plans_id
                      .filter((plan: any) => plan !== null)
                      .map((plan: any) => plan.section_title)
                  : []),
              ]
                .filter((title) => title)
                .join(', ')
            : [
                ...(this.newLessonPlan.pacing_plan_id?.length > 0
                  ? this.newLessonPlan.pacing_plan_id
                      .filter((plan: any) => plan !== null)
                      .map((plan: any) => plan.section_title)
                  : []),
                ...(this.newLessonPlan.teacher_custom_pacing_plans_id?.length > 0
                  ? this.newLessonPlan.teacher_custom_pacing_plans_id
                      .filter((plan: any) => plan !== null)
                      .map((plan: any) => plan.section_title)
                  : []),
              ]
                .filter((title) => title)
                .join(', '),
        subject_id: this.lessonPlan
          ? this.lessonPlan.lesson_plan.pacing_plan_id[0]?.subject_id
            ? this.lessonPlan.lesson_plan.pacing_plan_id[0]?.subject_id
            : this.lessonPlan.lesson_plan.teacher_custom_pacing_plans_id[0]?.subject_id
          : this.newLessonPlan.user_id
            ? this.newLessonPlan.lesson_plan.pacing_plan_id[0]
              ? this.newLessonPlan.lesson_plan.pacing_plan_id[0].subject_id
              : this.newLessonPlan.lesson_plan.teacher_custom_pacing_plans_id[0].subject_id
            : this.newLessonPlan.pacing_plan_id.length > 0
              ? this.newLessonPlan.pacing_plan_id[0].subject_id
              : this.newLessonPlan.teacher_custom_pacing_plans_id[0].subject_id,

        grades_id: this.lessonPlan
          ? this.lessonPlan.lesson_plan.pacing_plan_id[0]?.grades_id
            ? this.lessonPlan.lesson_plan.pacing_plan_id[0]?.grades_id
            : this.lessonPlan.lesson_plan.teacher_custom_pacing_plans_id[0]?.grades_id
          : this.newLessonPlan.user_id
            ? this.newLessonPlan.lesson_plan.pacing_plan_id[0]
              ? this.newLessonPlan.lesson_plan.pacing_plan_id[0].grades_id
              : this.newLessonPlan.lesson_plan.teacher_custom_pacing_plans_id[0].grades_id
            : this.newLessonPlan.pacing_plan_id.length > 0
              ? this.newLessonPlan.pacing_plan_id[0].grades_id
              : this.newLessonPlan.teacher_custom_pacing_plans_id[0].grades_id,
        user_id: this.currentClassroom?.user_id ? this.currentClassroom?.user_id : this.user.user.id,
        school_id: this.user.user.school_id,
        open_time: new Date().getTime(),
        close_time: new Date(new Date().setDate(new Date().getDate() + 7)).getTime(),
        classroom_id: this.currentClassroom.id,
        // global_pacing_plan_id: Array.isArray(this.newLessonPlan?.pacing_plan_id)
        //   ? this.newLessonPlan?.pacing_plan_id.map((plan) => plan.id)
        //   : this.newLessonPlan?.pacing_plan_id?.id || null,
        // teacher_custom_pacing_plans_id: Array.isArray(this.newLessonPlan?.teacher_custom_pacing_plans_id)
        //   ? this.newLessonPlan?.teacher_custom_pacing_plans_id.map((plan) => plan?.id)
        //   : this.newLessonPlan?.teacher_custom_pacing_plans_id?.id || null,

        //Extracts pacing plan and custom pacing plan IDs from the current lesson plan, ensuring a consistent array of valid IDs.
        global_pacing_plan_id: this.lessonPlan
          ? Array.isArray(this.currentLessonPlan?.lesson_plan?.pacing_plan_id)
            ? this.currentLessonPlan.lesson_plan.pacing_plan_id.map((plan) => plan?.id).filter(Boolean)
            : []
          : Array.isArray(this.currentLessonPlan?.pacing_plan_id)
            ? this.currentLessonPlan?.pacing_plan_id.map((plan) => plan?.id).filter(Boolean)
            : [],

        teacher_custom_pacing_plans_id: this.lessonPlan
          ? Array.isArray(this.currentLessonPlan?.lesson_plan?.teacher_custom_pacing_plans_id)
            ? this.currentLessonPlan.lesson_plan.teacher_custom_pacing_plans_id.map((plan) => plan?.id).filter(Boolean)
            : []
          : Array.isArray(this.currentLessonPlan?.teacher_custom_pacing_plans_id)
            ? this.currentLessonPlan.teacher_custom_pacing_plans_id
                .map((plan) => plan?.id)
                .filter(Boolean) // Added the filter to remove null values
            : [],
      };

      if (this.lessonPlanForm.value.title !== '' && this.lessonPlanForm.value.author !== '') {
        body['extras'] = this.lessonPlanForm.value;
      }
      if (this.user.user.is_trial_user && this.currentClassroom.is_dummy) {
        body['is_dummy'] = true;
      }

      if (!this.user.user.is_trial_user && this.currentClassroom?.user_id !== this.user.user.id) {
        body['substitute_teacher_user_id'] = this.user.user.id;
      }
      //Show disclaimer popup if the teacher had added the documents, and lesson paln was global.
      // this.checkForMediaFileWarning(body, true);
      const response: any = await this.assignmentService.addAssignment(body);

      if (response && response.id) {
        await this.setInitialLessonPlanValues(true);
        this.dialogRef.close();
        this.router.navigate([
          '/test-quizzes/view-assignment',
          response.id,
          this.currentClassroom.id,
          lessonPlanId,
          false,
        ]);
        setTimeout(() => {
          if (this.addedMediaFile) {
            this.storageService.setItem('document', true);
          }
        }, 2000);
      }
    } catch (error) {
      console.log('createAssignmentAndRender', error);
    }
  }

  async getLessonPlanIfExist() {
    try {
      const date = this.route?.snapshot?.queryParams?.currentDate
        ? Number(this.route?.snapshot?.queryParams?.currentDate)
        : !this.newLessonPlan
          ? this.currentLessonPlan?.lesson_plan?.start
          : this.currentLessonPlan?.start;

      const params = {
        start: new Date(date).setHours(0, 0, 0, 0),
        end: new Date(date).setHours(23, 59, 59, 59),

        subject_id: !this.newLessonPlan
          ? this.currentLessonPlan.lesson_plan.pacing_plan_id[0].subject_id
          : this.currentLessonPlan.pacing_plan_id[0]
            ? this.currentLessonPlan.pacing_plan_id[0].subject_id
            : this.currentLessonPlan.teacher_custom_pacing_plans_id[0]
              ? this.currentLessonPlan.teacher_custom_pacing_plans_id[0].subject_id
              : this.currentLessonPlan.custom_global_pacing_plan.subject_id,

        grades_id: !this.newLessonPlan
          ? this.currentLessonPlan.lesson_plan.pacing_plan_id[0].grades_id
          : this.currentLessonPlan.pacing_plan_id[0]
            ? this.currentLessonPlan.pacing_plan_id[0].grades_id
            : this.currentLessonPlan.teacher_custom_pacing_plans_id[0]
              ? this.currentLessonPlan.teacher_custom_pacing_plans_id[0].grades_id
              : this.currentLessonPlan.custom_global_pacing_plan.grades_id,

        user_id: this.currentClassroom.user_id ? this.currentClassroom.user_id : this.user.user.id,
        classroom_id: this.classroomId,
      };

      if (this.user.user.is_trial_user && this.currentClassroom.is_dummy) {
        params['is_dummy'] = true;
      }

      const response = await this.lessonPlanService.getLessonPlanBySubjectGradeAndDate(params);

      this.existedLessonPlanIds = response?.map((x) => x.id);

      return response;
    } catch (error) {
      console.error('Error in getLessonPlanIfExist:', error);

      return undefined;
    }
  }

  async generateNewVersionLessonPlan() {
    try {
      this.spinner.show();
      if (this.dialogRef) this.dialogRef.close();

      const response = await this.getLessonPlanIfExist();

      if (response && response.length > 0) {
        this.dialogRef = this.dialogService.open(this.newLessonPlanContent);
      } else {
        this.openLessonPlanPrivacyDialog();
      }
      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      // console.log(error);
    }
  }

  back() {
    if (this.isStudent) {
      if (this.lessonPlan?.isExpand) {
        this.studentService.isExpand.emit({
          isExpand: true,
          compontentLabel: 'student-previous-lessons',
        });
      }

      this.router.navigateByUrl(`/dashboard/student-dashboard/${this.classroomId}`);
    } else {
      this.calendarService.viewDate = this.route?.snapshot?.queryParams?.currentDate
        ? new Date(Number(this.route.snapshot.queryParams.currentDate))
        : this.newLessonPlan
          ? new Date(this.newLessonPlan.start)
          : new Date(Number(this.lessonPlan.start));

      this.pacingPlanService.view = 'Day';

      if (this.route?.snapshot?.queryParams?.currentDashboardUserId) {
        this.router.navigate([
          '/test-quizzes/classroom-details-dashboard',
          Number(this.route?.snapshot?.queryParams?.currentDashboardUserId),
          this.user.user.school_id,
          false,
        ]);
      } else {
        this.lessonPlan && !this.isStudent
          ? this.router.navigate(['/test-quizzes/classroom-details', this.classroomId])
          : this.navigateBack.back();
      }

      this.pacingPlanService.isLessonPan.next(true);
      this.pacingPlanService.removeObservers();

      if (this.isSave) this.deleteQuestionsFromDatabase();
    }
  }

  deleteQuestionsFromDatabase() {
    try {
      if (this.difficultQuestionsInDatabase?.length > 0 || this.easyQuestionsInDatabase?.length > 0)
        this.deleteDifficultQuestionsFromDatabase();
    } catch (error) {
      // console.log(error)
    }
  }

  async deleteDifficultQuestionsFromDatabase() {
    try {
      const body = {
        difficult_questions: this.difficultQuestionsInDatabase,
        easy_questions: this.easyQuestionsInDatabase,
      };

      await this.lessonPlanService.delete_difficult_and_easy_questions(body);
    } catch (error) {
      // console.log(error)
    }
  }

  async deleteLessonPlanAndRender() {
    try {
      this.dialogRef.close();
      this.spinner.show();
      this.isDeleteLessonPlan = true;
      this.openLessonPlanPrivacyDialog(false);
      this.spinner.hide();
    } catch (error) {
      // console.log(error);
      this.spinner.hide();
    }
  }

  /**
   * @description This function formats the input text for PDF generation by replacing HTML line breaks with new lines and removing any other HTML tags.
   * @param text - The input text that may contain HTML tags and line breaks.
   * @returns Formatted text suitable for PDF output.
   */
  private formatTextForPdf(text: any): string {
    if (!text) return '';

    return text
      .replace(/<br\s*\/?>/gi, '\n') // convert <br> → new line
      .replace(/<\/?[^>]+(>|$)/g, ''); // remove any other HTML tags safely
  }

  /**
   *
   * @description This function normalizes the video URL by replacing 'youtube-nocookie.com' with 'youtube.com' to ensure consistent embedding and playback across platforms.
   * @param url - The input video URL that may contain 'youtube-nocookie.com'.
   * @returns The normalized video URL.
   */
  private normalizeVideoUrl(url: string): string {
    if (!url) return '';

    // Replace youtube-nocookie with youtube
    return url.replace('youtube-nocookie.com', 'youtube.com');
  }

  async makePdf() {
    try {
      this.spinner.show();
      const imgSrc = '/assets/images/favicon.png';

      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.src = imgSrc;
      img.onload = async () => {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        canvas.width = img.width;
        canvas.height = img.height;
        context.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        const docDefinition: any = {
          info: {
            title: 'Lesson Plan',
          },

          content: [
            {
              image: dataURL,
              width: 50,
              height: 50,
              alignments: 'center',
            },
            {
              text: 'RespondEDU',
              style: 'subheader',
              alignments: 'center',
            },
            {
              columns: [
                {
                  text: `Lesson Plan for ${this.addLessonPlanForm.value.grade} grade ${this.addLessonPlanForm.value.subject}`,
                  style: 'header',
                  alignments: 'center',
                },
              ],
            },
            {
              columns: [
                [
                  {
                    text: 'Grade',
                    style: 'formLabel',
                  },
                  {
                    text: this.addLessonPlanForm.value.grade,
                    style: 'inputValue',
                  },
                ],
                [
                  {
                    text: 'Subject',
                    style: 'formLabel',
                  },
                  {
                    text: this.addLessonPlanForm.value.subject,
                    style: 'inputValue',
                  },
                ],
              ],
            },
            {
              columns: [
                [
                  {
                    text: 'Info',
                    style: 'cardHeader',
                  },

                  {
                    text: 'Section Id',
                    style: 'formLabel',
                  },
                  {
                    text: this.addLessonPlanForm.value.sectionId,
                    style: 'inputValue',
                  },

                  {
                    text: 'Section Title',
                    style: ['formLabel', 'infoLabel'],
                  },
                  {
                    text: this.formatTextForPdf(this.addLessonPlanForm.value.sectionTitle), // Format the section title for PDF output
                    style: 'inputValue',
                  },

                  {
                    text: 'Objective',
                    style: ['formLabel', 'infoLabel'],
                  },
                  {
                    text: this.formatTextForPdf(this.addLessonPlanForm.value.objective), // Format the objective for PDF output
                    style: 'inputValue',
                  },

                  {
                    text: 'Anticipatory Set',
                    style: ['formLabel', 'infoLabel'],
                  },
                  {
                    text: this.formatTextForPdf(this.addLessonPlanForm.value.anticipatory_set), // Format the anticipatory set for PDF output
                    style: 'inputValue',
                  },
                ],
              ],
            },
            {
              columns: [
                [
                  {
                    text: 'Presentation',
                    style: 'cardHeader',
                  },
                  {
                    text: this.formatTextForPdf(this.addLessonPlanForm.value.presentation),
                    style: 'inputValue',
                  },
                ],
              ],
            },
            {
              columns: [
                [
                  {
                    text: 'Guided Practice Questions',
                    style: 'cardHeader',
                  },
                  {
                    text: this.formatTextForPdf(this.addLessonPlanForm.value.guided_practice_questions),
                    style: 'inputValue',
                  },
                ],
              ],
            },
            ...(this.addLessonPlanForm.value.easyQuestions
              ? [
                  {
                    columns: [
                      [
                        {
                          text: 'Easy Questions',
                          style: 'cardHeader',
                        },
                        {
                          text: this.formatTextForPdf(this.addLessonPlanForm.value.easyQuestions),
                          style: 'inputValue',
                        },
                      ],
                    ],
                  },
                ]
              : []),

            ...(this.addLessonPlanForm.value.difficultQuestions
              ? [
                  {
                    columns: [
                      [
                        {
                          text: 'Difficult Questions',
                          style: 'cardHeader',
                        },
                        {
                          text: this.formatTextForPdf(this.addLessonPlanForm.value.difficultQuestions),
                          style: 'inputValue',
                        },
                      ],
                    ],
                  },
                ]
              : []),

            {
              columns: [
                [
                  {
                    text: 'Homework Questions',
                    style: 'cardHeader',
                  },
                  {
                    text: this.formatTextForPdf(this.addLessonPlanForm.value.homework_questions),
                    style: 'inputValue',
                  },
                ],
              ],
            },
            {
              columns: [
                [
                  {
                    text: 'Closure',
                    style: 'cardHeader',
                  },
                  {
                    text: this.formatTextForPdf(this.addLessonPlanForm.value.closure),
                    style: 'inputValue',
                  },
                ],
              ],
            },
          ],
          styles: {
            header: {
              fontSize: 16,
              bold: true,
              margin: [0, 0, 0, 20],
            },
            formLabel: {
              fontSize: 12,
              bold: true,
            },
            inputValue: {
              fontSize: 11,
              bold: false,
            },
            cardHeader: {
              fontSize: 14,
              bold: true,
              margin: [0, 10, 0, 5],
            },
            linkValue: {
              fontSize: 11,
              color: '#175cd3',
            },
            infoLabel: {
              margin: [0, 5, 0, 0],
            },
          },
        };

        if (this.videoUrls?.length > 0) {
          const newArr: any = [
            {
              text: 'Presentation Source Urls',
              style: 'cardHeader',
            },
          ];
          for (const iterator of this.videoUrls) {
            // bypass the security and get the actual url from SafeResourceUrl, then normalize it and add to the pdf content
            const rawUrl: SafeResourceUrl = this.utilService.getSafeVideoUrl(
              iterator?.changingThisBreaksApplicationSecurity,
              false,
            );

            const finalUrl = this.normalizeVideoUrl(rawUrl as string);

            newArr.push({
              text: finalUrl,
              link: finalUrl,
              style: 'linkValue',
            });
          }

          docDefinition.content.push({
            columns: [newArr],
          });
        }

        if (this.lessonPlanMedia && this.lessonPlanMedia?.id) {
          const presentationSourceDocuments: any = [
            {
              text: 'Presentation Source Document',
              style: 'cardHeader',
            },
            {
              text: this.lessonPlanMedia?.media?.url,
              link: this.lessonPlanMedia?.media?.url,
              style: 'linkValue',
            },
          ];

          docDefinition.content.push({
            columns: [presentationSourceDocuments],
          });
        }
        pdfMake.createPdf(docDefinition).download('Respond-Edu-Lesson-Plan');
      };

      this.spinner.hide();
    } catch (error) {
      // console.log(error);
      this.spinner.hide();
    }
  }

  async convertToDataURL(imagePath: string) {
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.src = imagePath;

    img.onload = () => {
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      canvas.width = img.width;
      canvas.height = img.height;
      context.drawImage(img, 0, 0);
      const dataURL = canvas.toDataURL('image/png');

      return dataURL;
    };
  }

  async createPacingPlanAndPush() {
    try {
      this.spinner.show();
      const localStorageData = this.storageService.getItem('currentPushedLessonPlans');
      const currentDate = new Date(Number(this.route?.snapshot?.queryParams?.currentDate));
      const body = {
        start: currentDate.setHours(0, 0, 0, 0),
        end: currentDate.setHours(23, 59, 59, 59),
        user_id: this.user?.user?.id,
        subject_id: !this.newLessonPlan
          ? this.currentLessonPlan.lesson_plan.pacing_plan_id[0].subject_id
          : this.currentLessonPlan.pacing_plan_id.length > 0
            ? this.currentLessonPlan.pacing_plan_id[0].subject_id
            : this.currentLessonPlan.custom_global_pacing_plan_id.length > 0
              ? this.currentLessonPlan.custom_global_pacing_plan_id[0].subject_id
              : this.currentLessonPlan.teacher_custom_pacing_plans_id[0].subject_id,
        grades_id: !this.newLessonPlan
          ? this.currentLessonPlan.lesson_plan.pacing_plan_id[0].grades_id
          : this.currentLessonPlan.pacing_plan_id.length > 0
            ? this.currentLessonPlan.pacing_plan_id[0].grades_id
            : this.currentLessonPlan.custom_global_pacing_plan_id.length > 0
              ? this.currentLessonPlan.custom_global_pacing_plan_id[0].grades_id
              : this.currentLessonPlan.teacher_custom_pacing_plans_id[0].grades_id,
        reason:
          localStorageData.reason === 'Reteach Standard of Custom Choice'
            ? 'Reteach Standard of Custom Choice'
            : 'Reteach Standard of Choice',
        lesson_plan_pacing_id: !this.newLessonPlan
          ? this.currentLessonPlan.lesson_plan.pacing_plan_id[0].id
          : this.currentLessonPlan.pacing_plan_id.length > 0
            ? this.currentLessonPlan.pacing_plan_id[0].id
            : this.currentLessonPlan.teacher_custom_pacing_plans_id[0].id,
        classroom_id: this.classroomId,
        global_pacing_plan_id:
          localStorageData.reason === 'Reteach Standard of Custom Choice' ? null : localStorageData?.pacing_plan_id,
        custom_global_pacing_plan_id:
          localStorageData.reason === 'Reteach Standard of Custom Choice' ? localStorageData?.pacing_plan_id : null,
      };
      const response = await this.pacingPlanService.addTeacherPacingPlan(body);
      if (response && response.id) {
        await this.updateMultipleTeacherLessonPlans(currentDate);
        this.pacingPlanService.pacingPlanEvents = [];
        this.openLessonPlanPrivacyDialog();
      }

      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      console.log('createPacingPlanAndPush', error);
    }
  }

  async getAllLessonPlanEvents(timeStamp) {
    try {
      const body = {
        user_id: this.user.user.id,
        school_id: this.user.user.school_id,
        subject_id: !this.newLessonPlan
          ? this.currentLessonPlan.lesson_plan.pacing_planId[0].subject_id
          : this.currentLessonPlan?.pacing_plan_id[0]?.subject_id
            ? this.currentLessonPlan?.pacing_plan_id[0]?.subject_id
            : this.currentLessonPlan.teacher_custom_pacing_plans_id[0]?.subject_id,
        // grades_id: !this.newLessonPlan
        //   ? this.currentLessonPlan.lesson_plan.pacing_plan.grades_id
        //   : this.currentLessonPlan?.pacing_plan?.grades_id
        //   ? this.currentLessonPlan.pacing_plan.grades_id
        //   : this.currentLessonPlan.teacher_custom_pacing_plans.grades_id,

        grades_id: this.currentClassroom?.grades_id,
        start_time: new Date(timeStamp).setHours(0, 0, 0, 0),
        classroom_id: this.classroomId,
      };
      return await this.lessonPlanService.getTeacherLessonPlanByUserId(body);
    } catch (error) {
      console.log(error);
    }
  }

  async updateMultipleTeacherLessonPlans(timeStamp: any) {
    try {
      const lessonPlansToPush = [];

      const allLessonPlanEvents: any = await this.getAllLessonPlanEvents(timeStamp);
      const dates = await this.getUpdatedDates();
      for (const iterator of allLessonPlanEvents) {
        const currentIndex = dates.findIndex(
          (x: any) => new Date(x.start).toDateString() === new Date(iterator.start).toDateString(),
        );
        const currentPlan = dates[currentIndex + 1];
        let iteratorStartTime, iteratorEndTime;
        if (this.currentClassroom.extras['eventDates'].length > 0) {
          const allottedTime = this.teacherLessonPlanService.getTeacherPeriodsFromEvents(
            this.currentClassroom,
            currentPlan,
            this.currentLessonPlan,
            iterator,
          );
          iteratorStartTime = allottedTime.iteratorStartTime;
          iteratorEndTime = allottedTime.iteratorEndTime;
        }
        const newStart = new Date(currentPlan?.start).toDateString() + ' ' + iteratorStartTime;
        const newEnd = new Date(currentPlan?.end).toDateString() + ' ' + iteratorEndTime;

        const body = {
          start: new Date(newStart),
          end: new Date(newEnd),
          user_id: iterator.user_id,
          school_id: iterator.school_id,
          lesson_plan_id: iterator.lesson_plan.id,
          updates: iterator.updates,
          id: iterator.id,
          classroom_id: this.currentClassroom.id,
        };
        lessonPlansToPush.push(body);
      }
      if (lessonPlansToPush.length > 0) {
        const updatedLessonPlanBody = {
          teacher_lesson_plan: lessonPlansToPush,
        };
        await this.lessonPlanService.updateMultipleLessonPlanEvents(updatedLessonPlanBody);
      }
    } catch (error) {
      console.log('updateMultipleTeacherLessonPlans', error);
    }
  }

  async getUpdatedDates() {
    const dates = this.storageService.getItem('currentValidDates');
    return dates;
  }
  // Token used table functions
  // async getUserToken() {
  //   try {
  //     // restrict openAI calls
  //     this.userAccessToken = await this.utilService.getUserToken(this.user?.user);
  //   } catch (error) {
  //     console.log('LessonPlanComponent getUserToken', error);
  //   }
  // }
  // async updateTokenUsed() {
  //   try {
  //     // restrict openAI calls
  //     await this.utilService.updateTokenUsed(this.user?.user, this.userAccessToken);

  //     await this.getUserToken();
  //   } catch (error) {
  //     console.log('LessonPlanComponent updateTokenUsed', error);
  //   }
  // }

  public async generateLessonPlan() {
    try {
      this.spinner.show();
      if (this.lessonPlanForm.invalid) {
        Object.keys(this.lessonPlanForm.controls).forEach((field) => {
          const control = this.lessonPlanForm.get(field);

          control.markAsTouched({
            onlySelf: true,
          });
        });
        this.toasterService.showToast('Please fill in all mandatory fields', 'danger');
        this.spinner.hide();
        return;
      }

      if (!this.utilService.checkIfTokenLimitExceededAndCreditsOut(this.userAccessAIToken, this.user?.user)) {
        const multipleSectionTitles = this.addLessonPlanForm.value?.sectionTitle?.split('\n')?.join('and ');
        const prompt = `generate a lesson plan for ${
          this.newLessonPlan
            ? this.newLessonPlan?.lesson_plan?.pacing_plan_id.length > 0 &&
              this.newLessonPlan?.lesson_plan?.pacing_plan_id[0] !== null
              ? this.newLessonPlan?.lesson_plan?.pacing_plan_id?.[0]?.grades.grade
              : this.newLessonPlan?.lesson_plan?.teacher_custom_pacing_plans_id?.[0]?.grades.grade
            : this.lessonPlan?.lesson_plan?.pacing_plan_id.length > 0 &&
                this.lessonPlan?.lesson_plan?.pacing_plan_id[0] !== null
              ? this.lessonPlan?.lesson_plan?.pacing_plan_id?.[0]?.grades.grade
              : this.lessonPlan?.lesson_plan?.teacher_custom_pacing_plans_id?.[0]?.grades.grade
        } grade English standard "${multipleSectionTitles}" . We are reading "${this.lessonPlanForm.value.title}" by "${
          this.lessonPlanForm.value.author
        }", so orient the plan based on that story ${
          this.lessonPlanForm.value.chapter !== '' ? `and its chapter "${this.lessonPlanForm.value.chapter}"` : ''
        }. Simply Include 1. Objective, 2. Anticipatory Set, 3. Presentation (create a 3-5 minute presentation), 4. Guided Practice Questions (3 guided practice questions with their solutions), 5. Homework Questions (5 example homework questions in list format without answers) 6. Closure`;
        const openAIRes = await this.OpenAiAssistant.createThreadEnglishLessonPlan(prompt);

        if (openAIRes) {
          const splittedText = await this.getOpenAILessonPlan(openAIRes?.data?.response);
          if (splittedText) {
            this.englishLessonPlan = {
              objective: splittedText.objective
                ?.replace(/[&\/\\#\**,+()$~%'":*?<>{}]/g, '')
                .replace('2.', '')
                .trim(),
              anticipatory_set: splittedText.anticipatory_set
                ?.replace(/[&\/\\#\**,+()$~%'":*?<>{}]/g, '')
                .replace('3.', '')
                .trim(),
              presentation: splittedText.presentation
                ?.replace(/[&\/\\#\**,+()$~%'":*?<>{}]/g, '')
                .replace('4.', '')
                .trim(),
              guided_practice_questions: splittedText.guided_practice_questions
                ?.replace(/[&\/\\#\**,+()$~%'":*?<>{}]/g, '')
                .replace('5.', '')
                .trim(),
              homework_questions: splittedText.homework_questions?.replace(/[&\/\\#\**,+()$~%'":*?<>{}]/g, '').trim(),
              closure: splittedText.closure
                ?.replace(/[&\/\\#\**,+()$~%'":*?<>{}]/g, '')
                .replace('6.', '')
                .trim(),
            };
            this.englishlessonPlanForm.patchValue({
              presentation: this.englishLessonPlan.presentation,
              guided_practice_questions: this.englishLessonPlan.guided_practice_questions,
              homework_questions: this.englishLessonPlan.homework_questions,
              closure: this.englishLessonPlan.closure,
            });

            this.modalService.open(this.lessonPlanModal, {
              size: 'lg',
              modalDialogClass: 'mymodal',
              centered: true,
              backdrop: 'static',
              animation: true,
              keyboard: false,
              backdropClass: 'modal-backdrop',
              windowClass: 'custom-overlay-container',
            });

            await this.checkForUserAccessAITokenUpdate(this.user?.user, this.userAccessAIToken);
          } else {
            this.toasterService.showToast(`Our AI plan is not working, please try again after some time`, 'danger');
          }
        } else {
          this.toasterService.showToast(`Our AI plan is not working, please try again after some time`, 'danger');
        }
      }
      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      console.log('generateLessonPlan', error);
    }
  }
  async getOpenAILessonPlan(response: string) {
    try {
      response.replace('\n', ' ').replace('\n\n', ' ');

      const num = response.includes('Guided Practice Questions') ? 27 : 16;
      const homeWorkQNum = response.includes('Homework Questions') ? 19 : 9;

      const responseData = {
        objective: response.substring(response.indexOf('Objective') + 11, response.lastIndexOf('Anticipatory Set')),
        anticipatory_set: response.substring(
          response.indexOf('Anticipatory Set') + 18,
          response.lastIndexOf('Presentation'),
        ),
        presentation: response
          .substring(
            response.indexOf('Presentation') + 14,
            response.includes('Guided Practice Questions')
              ? response.lastIndexOf('Guided Practice Questions')
              : response.lastIndexOf('Guided Practice'),
          )
          ?.replace('3-5 minutes)', '')
          ?.replace('3-5 minutes', ''),
        guided_practice_questions: response
          .substring(
            response.includes('Guided Practice Questions')
              ? response.indexOf('Guided Practice Questions')
              : response.indexOf('Guided Practice') + num,
            response.includes('Homework Questions')
              ? response.lastIndexOf('Homework Questions')
              : response.lastIndexOf('Homework'),
          )
          ?.replace('Guided Practice Questions', '')
          ?.replace('Guided Practice Questions:', '')
          ?.replace('Guided Practice:', '')
          ?.replace('5.', ''),
        closure: response.substring(response.indexOf('Closure') + 8, response.lastIndexOf('')),
        homework_questions: response.indexOf('Homework Questions')
          ? response
              .substring(
                response.includes('Homework Questions')
                  ? response.lastIndexOf('Homework Questions')
                  : response.lastIndexOf('Homework') + homeWorkQNum,
                response.lastIndexOf('Closure'),
              )
              ?.replace('Homework Questions', '')
              ?.replace('Homework Questions:', '')
              ?.replace('Homework:', '')
              ?.replace('6.', '')
          : '',
      };

      return responseData;
    } catch (error) {
      // console.log(error);
    }
  }

  async patchEnglishLessonPlanForm() {
    try {
      this.isEnglishLessonPlan = true;
      this.addLessonPlanForm.patchValue({
        presentation: this.englishlessonPlanForm.value.presentation,
        guided_practice_questions: this.englishlessonPlanForm.value.guided_practice_questions,
        homework_questions: this.englishlessonPlanForm.value.homework_questions,
        closure: this.englishlessonPlanForm.value.closure,
      });
      this.localStorageService.setItem('englishStoryData', {
        ...(this.lessonPlanForm.value ? this.lessonPlanForm.value : this.lessonPlan),
        isEnglishLessonPlan: this.lessonPlanForm.value === '' ? false : true, // Add the new key with the desired value
        presentation: this.englishlessonPlanForm.value.presentation,
        guided_practice_questions: this.englishlessonPlanForm.value.guided_practice_questions,
        homework_questions: this.englishlessonPlanForm.value.homework_questions,
        closure: this.englishlessonPlanForm.value.closure,
      });
    } catch (error) {
      // console.log(error);
    }
  }
  async clearEnglishLessonPlan() {
    try {
      this.lessonPlanForm.patchValue({
        title: '',
        author: '',
        chapter: '',
      });

      this.englishlessonPlanForm.patchValue({
        objective: '',
        anticipatory_set: '',
        presentation: '',
        guided_practice_questions: '',
        homework_questions: '',
        closure: '',
      });
    } catch (error) {
      // console.log(error);
    }
  }

  formatText(text: string): string {
    return text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  }

  getPanelClass() {
    switch (this.privacyOption) {
      case 1:
        return 'lessonPlanPrivacyDialog';
      case 2:
        return 'school-share-dialog';
      case 3:
        return 'private-share-dialog';
      default:
        return 'lessonPlanPrivacyDialog';
    }
  }

  // formatted output
  getFormattedAnswer(formControl: string): string {
    return this.utilService.getFormattedAnswerWithString(this.addLessonPlanForm.get(formControl).value, false);
  }

  // checkForMediaFileWarning(body, lessonPlanExit) {
  //   const document = this.storageService.getItem('document');
  //   const privacyOption = lessonPlanExit
  //     ? this.lessonPlan?.teacher_lesson_plan_privacy_id || 1
  //     : body.teacher_lesson_plan_privacy_id;
  // if (privacyOption === 1 && document) {
  //   setTimeout(() => {
  //     this.dialogRef = this.dialogService.open(this.uploadedDocument);
  //   }, 2000);
  // }
  // }

  //AI credit Tokens
  async getUserAIToken() {
    try {
      // restrict openAI calls
      this.userAccessAIToken = await this.utilService.getUserAITokens(this.user?.user.id);
    } catch (error) {
      console.log('LessonPlanComponent getUserToken', error);
    }
  }

  async updateAITokenUsed() {
    try {
      // restrict openAI calls
      await this.utilService.updateUserAITokens(this.user?.user.id, this.userAccessAIToken);

      await this.getUserAIToken();
    } catch (error) {
      console.log('LessonPlanComponent updateTokenUsed', error);
    }
  }

  /**
   * @description Determines whether a user's AI token usage should be updated based on role and access rules.
   * Ensures restricted users (teachers, trial users) consume tokens only when not on unlimited plans.
   * @param params.user - Contains role, school limitations, and trial status for access control
   * @param params.userAccessAIToken - Contains token configuration such as unlimited usage flag
   * @returns {Promise<void>} - Resolves after updating token usage if conditions are met
   */
  async checkForUserAccessAITokenUpdate(user: any, userAccessAIToken: any): Promise<void> {
    // Determine user roles using storage service
    const isTeacher = this.storageService.checkUserRole(user?.role_id, UserRoles.Teacher);
    const isTeacherOnly = this.storageService.checkUserRole(user?.role_id, UserRoles.TeacherOnly);
    // Convert trial flag to strict boolean
    const isTrialUser = Boolean(user?.is_trial_user);
    // Normalize unlimited flag (handles both boolean and string values like "true")
    const isUnlimited = String(userAccessAIToken?.is_unlimited) === 'true';
    // Safely access school limitations array (fallback to index 0 if index 1 is unavailable)
    const limitations = user?.school?.user_limitations || [];
    const limitedAccessRaw = limitations?.[1]?.isLimitedAccess ?? limitations?.[0]?.isLimitedAccess;
    // Normalize limited access flag
    const isLimitedAccess = String(limitedAccessRaw) === 'true';
    // Condition 1:
    // Teacher with limited access and not on unlimited plan → consume token
    if (isTeacher && isLimitedAccess && !isUnlimited) {
      await this.updateAITokenUsed();
      return;
    }
    // Condition 2:
    // TeacherOnly role without unlimited access → consume token
    if (isTeacherOnly && !isUnlimited) {
      await this.updateAITokenUsed();
      return;
    }
    // Condition 3:
    // Trial user without unlimited access → consume token
    if (isTrialUser && !isUnlimited) {
      await this.updateAITokenUsed();
      return;
    }
  }

  async setInitialLessonPlanValues(splitQuestionsAgain?: boolean) {
    await this.getLessonPlansById(splitQuestionsAgain);
  }

  // get the question for lesson plan
  async getLessonPlansById(isSplitAgain?: boolean) {
    try {
      this.spinner.show();
      const questions = this.storageService.getItem('homeworkAssignmentQuestions');

      if (!Array.isArray(questions)) {
        this.homeworkAssignmentQuestion = [];
      } else {
        this.homeworkAssignmentQuestion = questions;
      }

      if (isSplitAgain === true && this.homeworkAssignmentQuestion.length === 0) {
        const body = {
          questions:
            this.addLessonPlanForm.value.homework_questions ??
            this.currentLessonPlan?.homework_questions ??
            this.currentLessonPlan?.lesson_plan?.homework_questions,
        };

        const fullResponse = await new Promise<string>(async (resolve, reject) => {
          let buffer = '';

          (await this.OpenAiAssistant.splitQuestions(body)).subscribe({
            next: (streamChunk: { response?: string; end?: boolean }) => {
              if (streamChunk?.response) {
                buffer += streamChunk.response;
              }

              if (streamChunk?.end) {
                // this.isComplete$.next(true);
                resolve(buffer);
              }
            },
            error: (err) => {
              console.error('Stream error:', err);
              reject(err);
            },
          });
        });

        const parsed = JSON.parse(fullResponse);
        this.lessonPlanQuestions = this.lessonPlanQuestions?.length > 0 ? this.lessonPlanQuestions : parsed.questions;

        this.storageService.setItem('homeworkAssignmentQuestions', this.lessonPlanQuestions);
        this.spinner.hide();
      } else {
        this.lessonPlanQuestions = this.homeworkAssignmentQuestion;
      }
      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      console.error('❌ Error in getLessonPlansById:', error);
    }
  }

  async getTeacherLessonPlans(): Promise<any[]> {
    try {
      const body = {
        lesson_plan_id: this.baseLessonPlanId,
        privacy_id: this.privacyOption,
        school_id: this.user?.user?.school_id,
      };
      return (await this.lessonPlanService.getAllTeacherLessonPlans(body)) || [];
    } catch (error) {
      console.error('Error in getTeacherLessonPlans:', error);
      return [];
    }
  }

  // function for adding rank to teacher lesson plan
  async addRankToTeacherLessonPlan(params) {
    try {
      if (!this.isDeleteLessonPlan) {
        // add ranking to the lesson plan
        const lessonPlanExists = await this.getLessonPlanIfExist();
        if (!this.isAIGeneratedPlan && lessonPlanExists.length > 0) {
          const currentlyUpdatedSurvey = await this.lessonPlanService.getTeacherLessonPlanById(
            params.teacher_lesson_plan_id,
          );
          if (currentlyUpdatedSurvey.id && currentlyUpdatedSurvey.id > 0) {
            const existingUpdate = currentlyUpdatedSurvey.updates.find((update) => 'ranking_points' in update);
            if (existingUpdate) {
              existingUpdate.ranking_points = (existingUpdate.ranking_points || 0) + 1;
            } else {
              currentlyUpdatedSurvey.updates.push({ ranking_points: 1 });
            }
            // currentlyUpdatedSurvey['ranking_points'] = (currentlyUpdatedSurvey.ranking_points || 0) + 1;
            await this.lessonPlanService.updateTeacherLessonPlan(currentlyUpdatedSurvey.id, currentlyUpdatedSurvey);
          }
        }
      }
    } catch (error) {}
  }

  // function for saving the video URLs on the save button
  saveSelectedYouTubeUrls() {
    try {
      // Copy selected videos to main array
      this.videoUrls = [...this.tempSelectedVideoUrls];

      //  this.extractVideoIds();
      //  this.loadYouTubeAPI();
      this.tempSelectedVideoUrls = []; // Optional: clear after save
      this.matDialog.closeAll();
    } catch (error) {
      console.error('Error in saveSelectedYouTubeUrls:', error);
    }
  }

  // function for highlighting selected videos
  isVideoSelected(video: SafeResourceUrl): boolean {
    const videoUrl = video['changingThisBreaksApplicationSecurity'] || video.toString();
    return this.tempSelectedVideoUrls.some(
      (v: any) => (v['changingThisBreaksApplicationSecurity'] || v.toString()) === videoUrl,
    );
  }

  //function to convert YouTube playlist video links into direct video URLs
  convertToDirectYouTubeLink(url: string): string {
    try {
      const urlObj = new URL(url);

      // Handle shortened youtu.be links
      if (urlObj.hostname.includes('youtu.be')) {
        const videoId = urlObj.pathname.slice(1); // remove the leading '/'
        return `https://www.youtube-nocookie.com/embed/${videoId}`;
      }

      // Handle standard youtube-nocookie.com links
      const videoId = urlObj.searchParams.get('v');
      if (videoId) {
        return `https://www.youtube-nocookie.com/embed/${videoId}`;
      }

      // Return original if no video ID is found
      return url;
    } catch (error) {
      console.error('Invalid YouTube URL:', url);
      return url;
    }
  }

  /**
   * @description Sending the first classroom setup mail for teacher-only user
   */
  async sendMailAfterFirstClassroomSetup(user: any): Promise<void> {
    try {
      const emailBody = await this.emailService.getEmailBody(user, EMAIL_TEMPLATE_TYPE.FIRST_CLASSROOM_SETUP_MAIL);
      await this.authService.sendUserEmail(emailBody);
    } catch (error) {}
    console.log('🚀 ~ lesson-plan.component.ts:2988 ~ LessonPlanComponent ~ sendMailAfterFirstClassroomSetup ~ error:');
  }

  ngOnDestroy(): void {
    clearInterval(this.interval);
    this.storageService.removeItem('currentValidDates');
    this.storageService.removeItem('document');
    // Enable academic year header
    this.academicYearService.disableAcademicHeader.next(false);

    if (this.presentationStreamSub) {
      this.presentationStreamSub.unsubscribe();
    }

    // this.storageService.removeItem('englishStoryData');
  }
}
